// This file is auto-generated by @hey-api/openapi-ts

export type Body_update_master_chases_bulk_chases_provider_bulk_patch = {
    master_chase_update_request: MasterChaseUpdateRequest;
    master_chase_uuids_legacy_ids_dict: {
        [key: string]: {
            [key: string]: unknown;
        };
    };
};

export type Body_update_master_chases_with_data_coordinate_pk_ids_bulk_chases_provider_bulk_v2_patch = {
    master_chase_update_request: MasterChaseUpdateRequest;
    data_coordinate_pk_ids: Array<(number)>;
};

export type BulkUpload = {
    /**
     * The unique identifier of the bulk upload
     */
    bulk_upload_id: number;
    /**
     * The UUID of the bulk upload, used for tracking and identification
     */
    uuid: string;
    /**
     * The unique identifier for the tenant associated with the bulk upload
     */
    tenant_id: string;
    /**
     * DateTime when the bulk upload was created
     */
    created_at: string;
    /**
     * DateTime when the bulk upload was last updated
     */
    updated_at: string | null;
    /**
     * The number of files in the bulk upload
     */
    num_files: number;
    /**
     * The outreach ID associated with the bulk upload
     */
    outreach_id?: number | null;
    /**
     * The provider package display ID associated with the bulk upload
     */
    provider_package_display_id?: string | null;
    /**
     * Information about the files in the bulk upload
     */
    files: Array<BulkUploadFile>;
};

export type BulkUploadAiProcessedResult = {
    pk_id: number;
    group_id: string;
    reference_id?: string | null;
    original_file_upload_uuids: Array<(string)>;
    generated_file_upload_uuid?: string | null;
    final_cdr_uuid?: string | null;
    original_cdr_uuids?: Array<(string)> | null;
    status: BulkUploadAiProcessingResultEnum;
    upload_origin: BulkUploadAiProcessingUploadOriginEnum;
    created_at: string;
    updated_at: string;
};

export type BulkUploadAiProcessingRequestOriginEnum = 'CHARTFINDER' | 'HUB' | 'IDSB';

export const BulkUploadAiProcessingRequestOriginEnum = {
    CHARTFINDER: 'CHARTFINDER',
    HUB: 'HUB',
    IDSB: 'IDSB'
} as const;

export type BulkUploadAiProcessingResultEnum = 'SUCCESS' | 'MULTIPLE_PATIENTS_FOUND_FAILURE' | 'NO_PATIENTS_FOUND_FAILURE' | 'NO_GROUP_MATCH_FAILURE' | 'MULTIPLE_MATCHES_IN_GROUP_FAILURE' | 'NO_CHARTS_IN_GROUP_FAILURE';

export const BulkUploadAiProcessingResultEnum = {
    SUCCESS: 'SUCCESS',
    MULTIPLE_PATIENTS_FOUND_FAILURE: 'MULTIPLE_PATIENTS_FOUND_FAILURE',
    NO_PATIENTS_FOUND_FAILURE: 'NO_PATIENTS_FOUND_FAILURE',
    NO_GROUP_MATCH_FAILURE: 'NO_GROUP_MATCH_FAILURE',
    MULTIPLE_MATCHES_IN_GROUP_FAILURE: 'MULTIPLE_MATCHES_IN_GROUP_FAILURE',
    NO_CHARTS_IN_GROUP_FAILURE: 'NO_CHARTS_IN_GROUP_FAILURE'
} as const;

export type BulkUploadAiProcessingUploadOriginEnum = 'RMS' | 'RMB';

export const BulkUploadAiProcessingUploadOriginEnum = {
    RMS: 'RMS',
    RMB: 'RMB'
} as const;

export type BulkUploadAiRawResult = {
    pk_id: number;
    cdr_uuid: string;
    original_file_upload_uuid?: string | null;
    group_id: string;
    patient_info?: Array<{
    [key: string]: unknown;
}> | null;
    request_origin: BulkUploadAiProcessingRequestOriginEnum;
    upload_origin: BulkUploadAiProcessingUploadOriginEnum;
    created_at: string;
    updated_at: string;
};

export type BulkUploadFile = {
    /**
     * The name of the uploaded file
     */
    file_name: string;
    /**
     * The UUID of the uploaded file
     */
    uuid: string;
    /**
     * The name of the file that provider specified
     */
    provider_specified_file_name?: string | null;
    /**
     * The path of the uploaded file
     */
    file_path: string;
    /**
     * The status of the file
     */
    file_status: BulkUploadFileStatus;
    /**
     * Metadata about the file status
     */
    file_status_metadata: {
        [key: string]: unknown;
    };
    /**
     * DateTime when the file was uploaded
     */
    created_at: string;
    /**
     * DateTime when the file was last updated
     */
    updated_at: string | null;
    /**
     * The cdr uuid for file
     */
    cdr_uuid?: string | null;
};

export type BulkUploadFilePatchRequest = {
    /**
     * The UUID of the file
     */
    uuid: string;
    /**
     * The name of the uploaded file
     */
    file_name?: string | null;
    /**
     * The name of the file that provider specified
     */
    provider_specified_file_name?: string | null;
    /**
     * The path of the uploaded file
     */
    file_path?: string | null;
    /**
     * The status of the file
     */
    file_status?: BulkUploadFileStatus | null;
    /**
     * Metadata about the file status
     */
    file_status_metadata?: {
    [key: string]: unknown;
} | null;
    /**
     * The cdr uuid for file
     */
    cdr_uuid?: string | null;
};

export type BulkUploadFileRequest = {
    /**
     * The name of the uploaded file
     */
    file_name: string;
    /**
     * The path of the uploaded file
     */
    file_path: string;
    /**
     * The name of the file that provider specified
     */
    provider_specified_file_name?: string | null;
    /**
     * The status of the file
     */
    file_status?: BulkUploadFileStatus;
    /**
     * Metadata about the file status
     */
    file_status_metadata?: {
        [key: string]: unknown;
    };
    /**
     * The cdr uuid for file
     */
    cdr_uuid?: string | null;
};

export type BulkUploadFileStatus = 'UPLOADED_S3' | 'UPLOADING_AZURE_FILESHARE' | 'UPLOADING_AZURE_FILESHARE_FAILED' | 'UPLOADED_AZURE_FILESHARE' | 'UPLOADING_HUB_FAILED' | 'UPLOADING_HUB' | 'UPLOADED_HUB' | 'UPLOADING_CDR' | 'UPLOADING_CDR_FAILED' | 'UPLOADED_CDR' | 'AI_PROCESSING_SUCCESSFUL' | 'AI_PROCESSING_FAILED' | 'AI_RESULT_READY' | 'SENT_FOR_AI_PROCESSING';

export const BulkUploadFileStatus = {
    UPLOADED_S3: 'UPLOADED_S3',
    UPLOADING_AZURE_FILESHARE: 'UPLOADING_AZURE_FILESHARE',
    UPLOADING_AZURE_FILESHARE_FAILED: 'UPLOADING_AZURE_FILESHARE_FAILED',
    UPLOADED_AZURE_FILESHARE: 'UPLOADED_AZURE_FILESHARE',
    UPLOADING_HUB_FAILED: 'UPLOADING_HUB_FAILED',
    UPLOADING_HUB: 'UPLOADING_HUB',
    UPLOADED_HUB: 'UPLOADED_HUB',
    UPLOADING_CDR: 'UPLOADING_CDR',
    UPLOADING_CDR_FAILED: 'UPLOADING_CDR_FAILED',
    UPLOADED_CDR: 'UPLOADED_CDR',
    AI_PROCESSING_SUCCESSFUL: 'AI_PROCESSING_SUCCESSFUL',
    AI_PROCESSING_FAILED: 'AI_PROCESSING_FAILED',
    AI_RESULT_READY: 'AI_RESULT_READY',
    SENT_FOR_AI_PROCESSING: 'SENT_FOR_AI_PROCESSING'
} as const;

export type BulkUploadForOutreachFileRequest = {
    uuid: string;
    file_name: string;
    provider_specified_file_name?: string | null;
    file_path: string;
    file_size: string;
    user_uuid?: string | null;
    cdr_uuid?: string | null;
};

export type BulkUploadForOutreachRequest = {
    /**
     * Information about the files in the bulk upload
     */
    files: Array<BulkUploadForOutreachFileRequest>;
    /**
     * The optional chart id associated with the bulk upload
     */
    chart_id?: number | null;
    /**
     * The optional record request display id associated with the bulk upload
     */
    record_request_display_id?: string | null;
};

export type BulkUploadNoChildFiles = {
    /**
     * The unique identifier of the bulk upload
     */
    bulk_upload_id: number;
    /**
     * The UUID of the bulk upload, used for tracking and identification
     */
    uuid: string;
    /**
     * The unique identifier for the tenant associated with the bulk upload
     */
    tenant_id: string;
    /**
     * DateTime when the bulk upload was created
     */
    created_at: string;
    /**
     * DateTime when the bulk upload was last updated
     */
    updated_at: string | null;
    /**
     * The number of files in the bulk upload
     */
    num_files: number;
    /**
     * The outreach ID associated with the bulk upload
     */
    outreach_id?: number | null;
    /**
     * The provider package display ID associated with the bulk upload
     */
    provider_package_display_id?: string | null;
};

export type BulkUploadPatientAIResult = {
    /**
     * The starting page number for AI results
     */
    start_page_number: number;
    /**
     * The patient's first name extracted from AI results
     */
    first_name: string;
    /**
     * The patient's last name extracted from AI results
     */
    last_name: string;
    /**
     * The patient's date of birth extracted from AI results in yyyy-mm-dd format
     */
    date_of_birth: string;
};

export type BulkUploadRequest = {
    /**
     * Information about the files in the bulk upload
     */
    files: Array<BulkUploadFileRequest>;
    /**
     * The outreach ID associated with the bulk upload
     */
    outreach_id?: number | null;
    /**
     * The provider package display ID associated with the bulk upload
     */
    provider_package_display_id?: string | null;
    /**
     * The UUID of the bulk upload
     */
    upload_uuid: string;
};

export type ChartRepushRequest = {
    chart_ids: Array<(number)>;
};

export type ChartRepushResult = {
    successful_chart_uploads: Array<(number)>;
    failed_chart_uploads: Array<(number)>;
};

/**
 * Internal status of a Chase.
 *
 * CREATED                     :Chase has been created and is awaiting further action
 * GRACE_PERIOD_NEEDED         :Chase is waiting to start the grace period
 * GRACE_PERIOD_STARTED        :Chase is in the grace period and can be edited or cancelled
 * GRACE_PERIOD_ENDED          :Chase has exited the grace period and can no longer be edited or cancelled
 * PATIENT_CONSENT_REVIEW_REQUIRED    :Chase needs a review of the patient consent in order to be dispatched
 * PATIENT_CONSENT_REVIEW_DENIED      :Chase required patient consent but it was denied during review
 * READY_TO_DISPATCH           :Chase is ready to be dispatched and is waiting to be picked up
 * SENT_FOR_PROCESSING         :Chase has been sent to fulfillment method and is awaiting response
 * IN_PROCESSING               :Chase is currently being processed
 * CHARTS_NOT_FOUND            :Chase has not resulted in a chart
 * CHARTS_READY_FOR_DOWNLOAD   :Chase has charts that are ready to be downloaded from the retrieval source
 * CHARTS_BEING_DOWNLOADED     :We're currently downloaded the charts for this chase from the retrieval source
 * CHARTS_DOWNLOADED   :All charts for the chase are ready within the IDSB system
 * CANCELLED    :Chase has been intentionally cancelled
 * FAILED       :Chase has failed for unexpected reasons
 * PROVIDER_PACKET_NEEDED  :Chase needs a provider packet to be created and attached to be ready for dispatching
 * ACTION_NEEDED   :Chase requires action that isn't captured by other statuses
 * CHARTS_AVAILABLE:   :Chase has charts that have finished qc and are available for download
 * SENT_TO_CHARTFINDER_FOR_PROCESSING :A Provider has sent a response to Chartfinder, waiting for response from Chartfinder to update chase
 */
export type ChaseStatus = 'CREATED' | 'GRACE_PERIOD_NEEDED' | 'GRACE_PERIOD_STARTED' | 'GRACE_PERIOD_ENDED' | 'PROVIDER_PACKET_NEEDED' | 'PATIENT_CONSENT_REVIEW_REQUIRED' | 'PATIENT_CONSENT_REVIEW_DENIED' | 'READY_TO_DISPATCH' | 'SENT_FOR_PROCESSING' | 'IN_PROCESSING' | 'CHARTS_NOT_FOUND' | 'CHARTS_READY_FOR_DOWNLOAD' | 'CHARTS_BEING_DOWNLOADED' | 'CHARTS_DOWNLOADED' | 'CANCELLED' | 'FAILED' | 'PROVIDER_NOT_PARTICIPATING' | 'ACTION_NEEDED' | 'CHARTS_AVAILABLE' | 'SENT_TO_CHARTFINDER_FOR_PROCESSING';

/**
 * Internal status of a Chase.
 *
 * CREATED                     :Chase has been created and is awaiting further action
 * GRACE_PERIOD_NEEDED         :Chase is waiting to start the grace period
 * GRACE_PERIOD_STARTED        :Chase is in the grace period and can be edited or cancelled
 * GRACE_PERIOD_ENDED          :Chase has exited the grace period and can no longer be edited or cancelled
 * PATIENT_CONSENT_REVIEW_REQUIRED    :Chase needs a review of the patient consent in order to be dispatched
 * PATIENT_CONSENT_REVIEW_DENIED      :Chase required patient consent but it was denied during review
 * READY_TO_DISPATCH           :Chase is ready to be dispatched and is waiting to be picked up
 * SENT_FOR_PROCESSING         :Chase has been sent to fulfillment method and is awaiting response
 * IN_PROCESSING               :Chase is currently being processed
 * CHARTS_NOT_FOUND            :Chase has not resulted in a chart
 * CHARTS_READY_FOR_DOWNLOAD   :Chase has charts that are ready to be downloaded from the retrieval source
 * CHARTS_BEING_DOWNLOADED     :We're currently downloaded the charts for this chase from the retrieval source
 * CHARTS_DOWNLOADED   :All charts for the chase are ready within the IDSB system
 * CANCELLED    :Chase has been intentionally cancelled
 * FAILED       :Chase has failed for unexpected reasons
 * PROVIDER_PACKET_NEEDED  :Chase needs a provider packet to be created and attached to be ready for dispatching
 * ACTION_NEEDED   :Chase requires action that isn't captured by other statuses
 * CHARTS_AVAILABLE:   :Chase has charts that have finished qc and are available for download
 * SENT_TO_CHARTFINDER_FOR_PROCESSING :A Provider has sent a response to Chartfinder, waiting for response from Chartfinder to update chase
 */
export const ChaseStatus = {
    CREATED: 'CREATED',
    GRACE_PERIOD_NEEDED: 'GRACE_PERIOD_NEEDED',
    GRACE_PERIOD_STARTED: 'GRACE_PERIOD_STARTED',
    GRACE_PERIOD_ENDED: 'GRACE_PERIOD_ENDED',
    PROVIDER_PACKET_NEEDED: 'PROVIDER_PACKET_NEEDED',
    PATIENT_CONSENT_REVIEW_REQUIRED: 'PATIENT_CONSENT_REVIEW_REQUIRED',
    PATIENT_CONSENT_REVIEW_DENIED: 'PATIENT_CONSENT_REVIEW_DENIED',
    READY_TO_DISPATCH: 'READY_TO_DISPATCH',
    SENT_FOR_PROCESSING: 'SENT_FOR_PROCESSING',
    IN_PROCESSING: 'IN_PROCESSING',
    CHARTS_NOT_FOUND: 'CHARTS_NOT_FOUND',
    CHARTS_READY_FOR_DOWNLOAD: 'CHARTS_READY_FOR_DOWNLOAD',
    CHARTS_BEING_DOWNLOADED: 'CHARTS_BEING_DOWNLOADED',
    CHARTS_DOWNLOADED: 'CHARTS_DOWNLOADED',
    CANCELLED: 'CANCELLED',
    FAILED: 'FAILED',
    PROVIDER_NOT_PARTICIPATING: 'PROVIDER_NOT_PARTICIPATING',
    ACTION_NEEDED: 'ACTION_NEEDED',
    CHARTS_AVAILABLE: 'CHARTS_AVAILABLE',
    SENT_TO_CHARTFINDER_FOR_PROCESSING: 'SENT_TO_CHARTFINDER_FOR_PROCESSING'
} as const;

export type ClearPreviousEnum = 'ALL' | 'FAILED' | 'IN_PROGRESS';

export const ClearPreviousEnum = {
    ALL: 'ALL',
    FAILED: 'FAILED',
    IN_PROGRESS: 'IN_PROGRESS'
} as const;

export type CreateAddressFeedbackRequest = {
    /**
     * The tenant UUID the feedback is for.
     */
    tenant_uuid: string;
    /**
     * The provider user's UUID who submitted the feedback.
     */
    user_uuid: string;
    /**
     * The addresses that are being submitted for feedback.
     */
    addresses: Array<DigitalAddressFeedback>;
};

export type CreateAddressFeedbackSnowflakeRequest = {
    /**
     * The tenant UUID the feedback is for.
     */
    tenant_uuid: string;
    /**
     * The name of the health system.
     */
    health_system_name: string;
    /**
     * The digital site ID.
     */
    digital_site_id: number;
    /**
     * The health system ID.
     */
    health_system_id: string;
    /**
     * The EMR system used.
     */
    emr: string;
    /**
     * Digital connection type.
     */
    connection_type: string;
};

export type CreateAiRawResultParams = {
    cdr_uuid: string;
    group_id: string;
    request_origin: BulkUploadAiProcessingRequestOriginEnum;
    upload_origin: BulkUploadAiProcessingUploadOriginEnum;
    original_file_upload_uuid?: string | null;
};

export type CreateDigitalAgreement = {
    /**
     * The tenant UUID of the user that signed the agreement.
     */
    tenant_uuid: string;
    /**
     * The provider user's UUID who signed the agreement.
     */
    user_uuid: string;
    /**
     * The ID of the agreement that the user signed.
     */
    agreement_id: string;
};

export type CreateDigitalEncounterFeedback = {
    /**
     * UUID of the tenant associated to the encounter feedback
     */
    tenant_uuid: string;
    /**
     * List of encounter feedback entries to be created
     */
    encounters: Array<CreateDigitalEncounterFeedbackEntry>;
};

export type CreateDigitalEncounterFeedbackEntry = {
    /**
     * The encounter type name
     */
    encounter_type: string;
    /**
     * Whether the encounter type is active for autofulfillment
     */
    active: boolean;
};

export type CreateDigitalScannedDocumentFeedback = {
    /**
     * UUID of the tenant associated to the scanned document feedback
     */
    tenant_uuid: string;
    /**
     * List of scanned document feedback entries to be created
     */
    documents: Array<CreateDigitalScannedDocumentFeedbackEntry>;
};

export type CreateDigitalScannedDocumentFeedbackEntry = {
    /**
     * The scanned document category name
     */
    document_category: string;
    /**
     * Whether the document category is active for autofulfillment
     */
    active: boolean;
};

export type DataCoordinateCountRequest = {
    health_system_filters: DataCoordinateHealthSystemFilters;
    search_filters?: DataCoordinateSearchFilters | null;
    include_provider_verification_filter?: boolean | null;
};

export type DataCoordinateEmailNotificationResponse = {
    /**
     * Count of chases due in 7 days (less than or equal to 7 days from today). The display date is used if it exists, otherwise the due date.
     */
    count_due_in_7_days?: number;
    /**
     * Total count of pending chases.
     */
    count_total?: number;
    /**
     * Key: Group ID, Value: dict containing 'request_origin'
     */
    group_ids_data?: {
        [key: string]: {
            [key: string]: (string);
        };
    };
};

export type DataCoordinateExpireAccepted = {
    tenant_uuid: string;
    status?: string;
};

export type DataCoordinateExpireRequest = {
    tenant_uuid: string;
    run_display_due_date_calculation?: boolean;
};

export type DataCoordinateForDeniedProvidersResponse = {
    data_coordinates: Array<PydanticDataCoordinate>;
};

export type DataCoordinateHealthSystemFilters = {
    cf_site_clean_ids?: Array<(number)> | null;
    phone_numbers?: Array<(string)> | null;
    fax_numbers?: Array<(string)> | null;
    health_system_ids?: Array<(string)> | null;
    df_master_address_keys?: Array<(string)> | null;
};

export type DataCoordinateHealthSystemFiltersInternal = {
    cf_site_clean_ids?: Array<(number)> | null;
    phone_numbers?: Array<(string)> | null;
    fax_numbers?: Array<(string)> | null;
    health_system_ids?: Array<(string)> | null;
    df_master_address_keys?: Array<(string)> | null;
};

export type DataCoordinateIdentifiersResponse = {
    phone_numbers?: Array<(string)>;
    fax_numbers?: Array<(string)>;
    health_system_ids?: Array<(string)>;
    master_address_keys?: Array<(string)>;
};

export type DataCoordinateQueueRequest = {
    health_system_filters: DataCoordinateHealthSystemFilters;
    search_filters: DataCoordinateSearchFilters | null;
    sort: DataCoordinateSort | null;
    limit: number | null;
    offset: number | null;
    include_total?: boolean | null;
    exclude_pnp?: boolean | null;
    include_provider_verification_filter?: boolean | null;
};

export type DataCoordinateQueueRequestInternal = {
    health_system_filters: DataCoordinateHealthSystemFiltersInternal;
    search_filters?: DataCoordinateSearchFilters | null;
    sort: DataCoordinateSort | null;
    limit: number | null;
    offset: number | null;
    include_total?: boolean | null;
    exclude_pnp?: boolean | null;
    include_provider_verification_filter?: boolean | null;
};

export type DataCoordinateQueueResponse = {
    data_coordinates: Array<PydanticDataCoordinate>;
    total: number;
};

export type DataCoordinateSearchFilters = {
    pk_ids?: Array<(number)> | null;
    global_search?: string | null;
    outreach_id?: number | null;
    chart_id?: number | null;
    chart_ids?: Array<(number)> | null;
    patient_name?: string | null;
    patient_dob?: string | null;
    statuses_include?: Array<RequestManagerRetrievalStatus> | null;
    statuses_exclude?: Array<RequestManagerRetrievalStatus> | null;
    practitioner_names?: Array<PractitionerName> | null;
    due_date_start?: string | null;
    due_date_end?: string | null;
    primary_reasons?: Array<PrimaryReason> | null;
    retrieval_methods?: Array<RequestManagerRetrievalMethod> | null;
    rra_filter?: RRAFilter | null;
    request_id?: string | null;
    reference_ids?: Array<(string)> | null;
    group_id?: string | null;
};

export type DataCoordinateSort = {
    option?: RequestManagerSortOption;
    direction?: "asc" | "desc";
};

export type DataCoordinateUpdateFields = {
    status?: RequestManagerRetrievalStatus | null;
    status_detail?: string | null;
    assigned_to_health_system_ids_to_add?: Array<(string)> | null;
    assigned_to_health_system_ids_to_remove?: Array<(string)> | null;
    fulfilled_by_health_system_id?: string | null;
    display_due_date?: string | null;
    cdr_document_id?: string | null;
};

export type DataCoordinateUpdateRequest = {
    health_system_id?: string | null;
    health_system_filters: DataCoordinateHealthSystemFilters;
    search_filters?: DataCoordinateSearchFilters | null;
    update_fields: DataCoordinateUpdateFields;
    exclude_pnp?: boolean | null;
};

export type DataCoordinateUpdateRequestInternal = {
    health_system_id?: string | null;
    health_system_filters: DataCoordinateHealthSystemFiltersInternal;
    search_filters?: DataCoordinateSearchFilters | null;
    update_fields: DataCoordinateUpdateFields;
    exclude_pnp?: boolean | null;
};

export type DedaSuccessfulEventRequest = {
    request_id: string;
    cdr_document_uuid: string;
};

export type DedaUnsuccessfulEventRequest = {
    request_id: string;
    reason: string;
};

export type DigitalAddressFeedback = {
    /**
     * Whether the address feedback is approved or not.
     */
    approved: boolean;
    /**
     * The address line 1 of the address feedback.
     */
    address_line_1: string;
    /**
     * The address line 2 of the address feedback.
     */
    address_line_2: string | null;
    /**
     * The city of the address feedback.
     */
    city: string;
    /**
     * The state of the address feedback.
     */
    state: string;
    /**
     * The postal code of the address feedback.
     */
    postal_code: string;
    /**
     * The Master Address Key of the address feedback.
     */
    mak: string;
};

export type DigitalAgreement = {
    /**
     * The primary key ID of the digital agreement.
     */
    pk_id: number;
    /**
     * The tenant UUID of the user that signed the agreement.
     */
    tenant_uuid: string;
    /**
     * The provider user's UUID who signed the agreement.
     */
    user_uuid: string;
    /**
     * The ID of the agreement that the user signed.
     */
    agreement_id: string;
    /**
     * Whether the agreement has been deleted.
     */
    deleted: boolean;
    /**
     * The timestamp when the agreement was created.
     */
    created_at: string;
    /**
     * The timestamp when the agreement was last updated.
     */
    updated_at: string;
};

export type DigitalEncounterFeedback = {
    /**
     * Id of the encounter feedback entry
     */
    pk_id: number;
    /**
     * UUID of the tenant associated to the encounter feedback
     */
    tenant_uuid: string;
    /**
     * The encounter type name
     */
    encounter_type: string;
    /**
     * Whether the encounter type is active for autofulfillment
     */
    active: boolean;
    /**
     * Date and time when the encounter feedback was created
     */
    created_at: string;
    /**
     * Date and time when the encounter feedback was last updated
     */
    updated_at: string | null;
};

export type DigitalQCBulkUpdateChart = {
    /**
     * The primary key of the Digital QC record.
     */
    pk_id?: number | null;
    /**
     * The data coordinate ID associated with the Digital QC record.
     */
    data_coordinate_pk_id?: number | null;
    /**
     * The status of the Digital QC record.
     */
    status?: StatusEnum | null;
    /**
     * The status message of the quality check fulfillment.
     */
    status_message?: string | null;
    /**
     * The CDR document location of the quality check records.
     */
    document_location?: string | null;
    /**
     * Whether the record was approved.
     */
    approved?: boolean | null;
    /**
     * The feedback categories for the Digital QC record.
     */
    feedback?: Array<RejectReasonsEnum> | null;
    /**
     * The feedback comment for the Digital QC record.
     */
    feedback_comment?: string | null;
    /**
     * The feedback email for the Digital QC record.
     */
    feedback_email?: string | null;
    /**
     * Whether the record was deleted.
     */
    deleted?: boolean | null;
};

export type DigitalQCBulkUpdateReponse = {
    /**
     * The list of successfully updated QC records.
     */
    successes: Array<PydanticQualityCheck>;
    /**
     * The pk_ids/data_coordinate_pk_ids of failed QC record updates.
     */
    failures: Array<(number)>;
};

export type DigitalQCBulkUpdateRequest = {
    charts: Array<DigitalQCBulkUpdateChart>;
};

export type DigitalQCBulkUpdateStatus = {
    /**
     * The reference ID (chart ID or data coordinate ID) associated with the quality check.
     */
    chart_id: number;
    /**
     * The status of the Digital QC record.
     */
    status?: StatusEnum | null;
    /**
     * The status message of the quality check fulfillment.
     */
    status_message?: string | null;
    /**
     * The CDR document location of the quality check records.
     */
    document_location?: string | null;
};

export type DigitalQCChart = {
    /**
     * The data coordinate primary key ID associated with the quality check.
     */
    data_coordinate_pk_id: number;
};

export type DigitalQCCreateRequest = {
    /**
     * The tenant UUID the quality check is for.
     */
    tenant_uuid: string;
    /**
     * The DVer email that triggered the quality check.
     */
    owner_email: string;
    /**
     * The charts that comprise the quality check.
     */
    charts?: Array<DigitalQCChart> | null;
    /**
     * Compliance requirements to make sure charts belong to health system.
     */
    health_system_filters: DataCoordinateHealthSystemFilters;
    /**
     * Whether to clear previous QC attempts when restarting QC.
     */
    clear_previous?: ClearPreviousEnum | null;
};

export type DigitalScannedDocumentFeedback = {
    /**
     * Id of the scanned document feedback entry
     */
    pk_id: number;
    /**
     * UUID of the tenant associated to the scanned document feedback
     */
    tenant_uuid: string;
    /**
     * The scanned document category name
     */
    document_category: string;
    /**
     * Whether the document category is active for autofulfillment
     */
    active: boolean;
    /**
     * Date and time when the scanned document feedback was created
     */
    created_at: string;
    /**
     * Date and time when the scanned document feedback was last updated
     */
    updated_at: string | null;
};

export type EmailNotificationsDataRequest = {
    health_system_filters: DataCoordinateHealthSystemFilters;
    include_provider_verification_filter?: boolean | null;
};

export type Error = {
    /**
     * Error code specifiying type of error
     */
    code: string;
    /**
     * Human readable message describing error
     */
    message: string;
    /**
     * The parameters involved in the error
     */
    params?: Array<unknown> | null;
};

export type ErrorHTTPResponse = {
    /**
     * List of all errors
     */
    errors: Array<Error>;
};

export type File = {
    file_id: number;
    file_name: string;
    provider_specified_file_name?: string | null;
    file_path: string;
    file_size: string;
    file_uuid: string;
    file_status: RMFileUploadStatus;
    file_status_metadata?: FileUploadStatusMetadata | null;
    user_uuid?: string | null;
    updated_at?: string;
    cdr_uuid?: string | null;
    is_auto_generated?: boolean | null;
};

export type FileUpload = {
    uuid: string;
    group_uuid: string;
    master_upload_id: number;
    files: Array<File>;
    created_at: string;
    updated_at?: string | null;
    file_upload_type: RMFileUploadType;
    outreach_id?: number | null;
    provider_package_display_id?: string | null;
    chart_id?: number | null;
    record_request_display_id?: string | null;
    num_files?: number | null;
    tenant_uuid?: string | null;
    chase_uuid?: string | null;
};

export type FileUploadEntry = {
    master_upload_id: number;
    file_id: number;
    file_status: RMFileUploadStatus;
    file_status_metadata?: FileUploadStatusMetadata | null;
    file_name: string;
    provider_specified_file_name?: string | null;
    file_path: string;
    created_at: string;
    updated_at?: string | null;
    user_uuid?: string | null;
    cdr_uuid?: string | null;
    uuid?: string | null;
    file_size?: string | null;
};

export type FileUploadStatusMetadata = {
    s3_object_key: string;
    azure_file_path?: string;
    cdr_uuid?: string;
    ai_single_upload_uuid?: string;
};

export type Gender = 'M' | 'F' | 'O' | 'U';

export const Gender = {
    M: 'M',
    F: 'F',
    O: 'O',
    U: 'U'
} as const;

export type GroupIdSearchRequest = {
    search_term: string;
    health_system_filters: DataCoordinateHealthSystemFilters;
    search_filters?: DataCoordinateSearchFilters | null;
    include_provider_verification_filter?: boolean | null;
};

export type GroupIdSearchResponse = {
    group_ids: Array<(string)>;
};

export type HTTPValidationError = {
    detail?: Array<ValidationError>;
};

export type ManualImportDataCoordinatesRequest = {
    provider_package_display_id: string;
    health_system_id: string;
};

export type ManualImportDataCoordinatesResponse = {
    imported_count: number;
};

export type ManualUploadFile = {
    /**
     * The unique identifier of the manual upload
     */
    pk_id: number;
    /**
     * The uuid of the manual upload
     */
    uuid: string;
    /**
     * The Chase ID associated with the manual upload
     */
    chase_pk_id: number;
    /**
     * The path of the uploaded file
     */
    file_path: string;
    /**
     * DateTime when the file was uploaded
     */
    uploaded_at: string;
};

export type ManualUploadFileRequest = {
    /**
     * The Chase UUID associated with the manual upload
     */
    chase_uuid: string;
    /**
     * The path of the uploaded file in S3
     */
    file_path: string;
};

/**
 * Model that captures the MasterChase data to be updated.
 */
export type MasterChaseUpdateRequest = {
    /**
     * The status of where the MasterChase is in its lifecycle (e.g. created, processing, failed, successful, etc.)
     */
    status: ChaseStatus | null;
    /**
     * Metadata/notes about the MasterChase's status (such as external status associated with the MasterChase domain status).
     */
    status_metadata: string | null;
    /**
     * The health system id that fulfilled a chase.
     */
    fulfilled_by_hs_id?: string | null;
};

export type NonEmbeddedImplementationStatus = 'EMR_SUBMITTED' | 'DOCUSIGN_COMPLETED' | 'CREDENTIALS_SUBMITTED' | 'CREDENTIALS_TEST_SUCCESSFUL' | 'CREDENTIALS_TEST_FAILED' | 'INSTALLED' | 'BACKLOAD_COMPLETED' | 'ENCOUNTER_FEEDBACK_COMPLETED' | 'SCANNED_DOCUMENT_FEEDBACK_COMPLETED' | 'QC_STARTED' | 'QC_FAILED' | 'QC_READY' | 'QC_COMPLETED' | 'ADDRESS_FEEDBACK_COMPLETED' | 'LIVE';

export const NonEmbeddedImplementationStatus = {
    EMR_SUBMITTED: 'EMR_SUBMITTED',
    DOCUSIGN_COMPLETED: 'DOCUSIGN_COMPLETED',
    CREDENTIALS_SUBMITTED: 'CREDENTIALS_SUBMITTED',
    CREDENTIALS_TEST_SUCCESSFUL: 'CREDENTIALS_TEST_SUCCESSFUL',
    CREDENTIALS_TEST_FAILED: 'CREDENTIALS_TEST_FAILED',
    INSTALLED: 'INSTALLED',
    BACKLOAD_COMPLETED: 'BACKLOAD_COMPLETED',
    ENCOUNTER_FEEDBACK_COMPLETED: 'ENCOUNTER_FEEDBACK_COMPLETED',
    SCANNED_DOCUMENT_FEEDBACK_COMPLETED: 'SCANNED_DOCUMENT_FEEDBACK_COMPLETED',
    QC_STARTED: 'QC_STARTED',
    QC_FAILED: 'QC_FAILED',
    QC_READY: 'QC_READY',
    QC_COMPLETED: 'QC_COMPLETED',
    ADDRESS_FEEDBACK_COMPLETED: 'ADDRESS_FEEDBACK_COMPLETED',
    LIVE: 'LIVE'
} as const;

export type OutreachNotificationsDataRequest = {
    health_system_filters: DataCoordinateHealthSystemFilters;
    include_provider_verification_filter?: boolean | null;
};

export type OutreachRepushRequest = {
    outreach_ids: Array<(number)>;
};

export type OutreachRepushResult = {
    successful_outreach_uploads: Array<(number)>;
    failed_outreach_uploads: Array<(number)>;
};

export type Page_DigitalEncounterFeedback_ = {
    items: Array<DigitalEncounterFeedback>;
    total: number;
    page: number;
    size: number;
    pages: number;
};

export type Page_DigitalScannedDocumentFeedback_ = {
    items: Array<DigitalScannedDocumentFeedback>;
    total: number;
    page: number;
    size: number;
    pages: number;
};

export type PatchAiRawResultPayload = {
    patient_info: Array<BulkUploadPatientAIResult>;
};

export type PatchFinalUuidPayload = {
    reference_id: string;
    final_cdr_uuid?: string | null;
    generated_file_upload_uuid?: string | null;
    created_at: string;
    upload_origin: BulkUploadAiProcessingUploadOriginEnum;
};

export type PostFailedAiMatchRequest = {
    group_id: string;
    reason: BulkUploadAiProcessingResultEnum;
    original_file_upload_uuid: string;
    original_cdr_uuid: string;
    upload_origin: BulkUploadAiProcessingUploadOriginEnum;
};

export type PractitionerInputRequest = {
    health_system_filters: DataCoordinateHealthSystemFilters;
    include_provider_verification_filter?: boolean | null;
};

export type PractitionerName = {
    first_name?: string | null;
    last_name?: string | null;
};

export type PrimaryReason = 'attorney' | 'hospital_lien' | 'patient_directive' | 'personal_injury' | 'social_security_disability' | 'subpoena' | 'workers_comp' | 'illinois_industrial_commission_subpoena' | 'florida_statute' | 'veterans_disability' | 'ssa_appeal_representative_form_1696' | 'patient_social_security_appeal' | 'life_sciences' | 'audit_of_claims' | 'clinical_research' | 'disability' | 'insurance' | 'medicare_medicaid' | 'rac' | 'revenue_cycle_management' | 'business_office_copy_risk_management' | 'special_project' | 'drg_payment_integrity' | 'hedis_audit' | 'hix' | 'radv' | 'standard_insurance_claim_payment' | 'utilization_review' | 'disability_gov_benefits' | 'forms_completion_by_provider' | 'patient_personal' | 'patient_transfer' | 'second_request_not_work_comp' | 'agency' | 'government_audit' | 'medicaid_dds' | 'non_profit' | 'state_dds' | 'workers_comp_board' | 'continuity_of_care' | 'ciox_audit' | 'mra' | 'ciox_real_world_data_team_request' | 'aca_hix' | 'drg' | 'underwriting' | 'claim' | 'general_attorney' | 'general_attorney_subpoena' | 'workers_comp_subpoena' | 'ssa_appeal' | 'pro_medicaid' | 'standard_pro' | 'value_based_care' | 'payd' | 'payer' | 'mcaid' | 'attestation' | 'unknown';

export const PrimaryReason = {
    ATTORNEY: 'attorney',
    HOSPITAL_LIEN: 'hospital_lien',
    PATIENT_DIRECTIVE: 'patient_directive',
    PERSONAL_INJURY: 'personal_injury',
    SOCIAL_SECURITY_DISABILITY: 'social_security_disability',
    SUBPOENA: 'subpoena',
    WORKERS_COMP: 'workers_comp',
    ILLINOIS_INDUSTRIAL_COMMISSION_SUBPOENA: 'illinois_industrial_commission_subpoena',
    FLORIDA_STATUTE: 'florida_statute',
    VETERANS_DISABILITY: 'veterans_disability',
    SSA_APPEAL_REPRESENTATIVE_FORM_1696: 'ssa_appeal_representative_form_1696',
    PATIENT_SOCIAL_SECURITY_APPEAL: 'patient_social_security_appeal',
    LIFE_SCIENCES: 'life_sciences',
    AUDIT_OF_CLAIMS: 'audit_of_claims',
    CLINICAL_RESEARCH: 'clinical_research',
    DISABILITY: 'disability',
    INSURANCE: 'insurance',
    MEDICARE_MEDICAID: 'medicare_medicaid',
    RAC: 'rac',
    REVENUE_CYCLE_MANAGEMENT: 'revenue_cycle_management',
    BUSINESS_OFFICE_COPY_RISK_MANAGEMENT: 'business_office_copy_risk_management',
    SPECIAL_PROJECT: 'special_project',
    DRG_PAYMENT_INTEGRITY: 'drg_payment_integrity',
    HEDIS_AUDIT: 'hedis_audit',
    HIX: 'hix',
    RADV: 'radv',
    STANDARD_INSURANCE_CLAIM_PAYMENT: 'standard_insurance_claim_payment',
    UTILIZATION_REVIEW: 'utilization_review',
    DISABILITY_GOV_BENEFITS: 'disability_gov_benefits',
    FORMS_COMPLETION_BY_PROVIDER: 'forms_completion_by_provider',
    PATIENT_PERSONAL: 'patient_personal',
    PATIENT_TRANSFER: 'patient_transfer',
    SECOND_REQUEST_NOT_WORK_COMP: 'second_request_not_work_comp',
    AGENCY: 'agency',
    GOVERNMENT_AUDIT: 'government_audit',
    MEDICAID_DDS: 'medicaid_dds',
    NON_PROFIT: 'non_profit',
    STATE_DDS: 'state_dds',
    WORKERS_COMP_BOARD: 'workers_comp_board',
    CONTINUITY_OF_CARE: 'continuity_of_care',
    CIOX_AUDIT: 'ciox_audit',
    MRA: 'mra',
    CIOX_REAL_WORLD_DATA_TEAM_REQUEST: 'ciox_real_world_data_team_request',
    ACA_HIX: 'aca_hix',
    DRG: 'drg',
    UNDERWRITING: 'underwriting',
    CLAIM: 'claim',
    GENERAL_ATTORNEY: 'general_attorney',
    GENERAL_ATTORNEY_SUBPOENA: 'general_attorney_subpoena',
    WORKERS_COMP_SUBPOENA: 'workers_comp_subpoena',
    SSA_APPEAL: 'ssa_appeal',
    PRO_MEDICAID: 'pro_medicaid',
    STANDARD_PRO: 'standard_pro',
    VALUE_BASED_CARE: 'value_based_care',
    PAYD: 'payd',
    PAYER: 'payer',
    MCAID: 'mcaid',
    ATTESTATION: 'attestation',
    UNKNOWN: 'unknown'
} as const;

export type ProviderVerificationCreateRequest = {
    health_system_id: string;
    provider_first_name?: string | null;
    provider_last_name?: string | null;
    is_verified: boolean;
    last_modified_by_user_uuid: string;
};

export type ProviderVerificationGetResponse = {
    verifications: Array<PydanticProviderVerificationDisplay>;
};

export type ProviderVerificationResponse = {
    pk_id: number;
    health_system_id: string;
    provider_first_name?: string | null;
    provider_last_name?: string | null;
    is_verified: boolean;
    created_at: string;
    updated_at: string;
    last_modified_by_user_uuid: string;
    deleted: boolean;
};

export type ProviderVerificationUpdateRequest = {
    health_system_id: string;
    provider_first_name?: string | null;
    provider_last_name?: string | null;
    is_verified?: boolean | null;
    last_modified_by_user_uuid?: string | null;
};

export type PydanticDataCoordinate = {
    /**
     * The primary key ID of the data coordinate.
     */
    pk_id?: number | null;
    /**
     * The external reference ID of the data coordinate. Used for display and communcation.
     */
    reference_id?: string | null;
    /**
     * The chart finder project ID. Only used when creating orders.
     */
    cf_project_id?: string | null;
    /**
     * The chart finder outreach ID.
     */
    cf_outreach_id?: number | null;
    /**
     * The chart finder chart ID. To be consolidated with reference_id.
     */
    cf_chart_id?: number | null;
    /**
     * The health system e-request ID.
     */
    hs_erequest_id?: number | null;
    /**
     * The chart finder site clean ID. Might be empty
     */
    cf_site_clean_id?: number | null;
    /**
     * The chart finder EMR site ID. Used to identify vend v.s. fhir worker
     */
    cf_emr_site_id?: string | null;
    /**
     * The list of health system IDs the chase is assigned to. Used for manual import
     */
    assigned_to_health_system_ids?: Array<(string)>;
    /**
     * The health system ID that fulfills the order.
     */
    fulfilled_by_health_system_id?: string | null;
    /**
     * The outreach's primary site's primary phone number.
     */
    primary_phone_num?: string | null;
    /**
     * The outreach's primary site's primary fax number.
     */
    primary_fax_num?: string | null;
    /**
     * The type of requester.
     */
    requester_type?: RequesterType | null;
    /**
     * The display name of the requester.
     */
    requester_display_name?: string | null;
    /**
     * The primary reason for the order.
     */
    primary_reason?: PrimaryReason | null;
    /**
     * The retrieval method.
     */
    retrieval_method?: RequestManagerRetrievalMethod | null;
    /**
     * The start date of the project.
     */
    project_start_date?: string | null;
    /**
     * The due date of the project.
     */
    project_due_date?: string | null;
    /**
     * The due date that we display to users. Most likely scheduled date.
     */
    display_due_date?: string | null;
    /**
     * The start date of the DOS.
     */
    dos_start_date?: string | null;
    /**
     * The end date of the DOS.
     */
    dos_end_date?: string | null;
    /**
     * The specific DOS as a list of date ranges in a string format.
     */
    sdos?: string | null;
    /**
     * The status of the chase.
     */
    status?: RequestManagerRetrievalStatus | null;
    /**
     * The detailed status of the chase.
     */
    status_detail?: string | null;
    /**
     * The first name of the patient.
     */
    patient_first_name?: string | null;
    /**
     * The last name of the patient.
     */
    patient_last_name?: string | null;
    /**
     * The sex of the patient.
     */
    patient_sex?: Gender | null;
    /**
     * The date of birth of the patient.
     */
    patient_date_of_birth?: string | null;
    /**
     * The first name of the practitioner.
     */
    practitioner_first_name?: string | null;
    /**
     * The last name of the practitioner.
     */
    practitioner_last_name?: string | null;
    /**
     * PNP counts of all providers assigned to this request.
     */
    pnp_counts?: {
    [key: string]: (number);
} | null;
    /**
     * Whether the provider is verified by the health system.
     */
    provider_is_verified?: boolean | null;
    /**
     * The chart tracking ID generated by IDSB (also referenced in CF).
     */
    chart_tracking_id?: number | null;
    /**
     * The IDSB group ID, synonymous to CF outreach ID.
     */
    idsb_group_id?: string | null;
    /**
     * The IDSB request ID. To be consolidated with reference_id.
     */
    idsb_request_id?: number | null;
    /**
     * The Data Foundation health system ID.
     */
    df_health_system_id?: string | null;
    /**
     * The Data Foundation master address key.
     */
    df_master_address_key?: string | null;
    /**
     * Created timestamp.
     */
    created_at?: string | null;
    /**
     * Last updated timestamp.
     */
    updated_at?: string | null;
    /**
     * Dedupes request with the same chart tracking ID, but different origin.
     */
    is_active?: boolean | null;
    /**
     * Determines which system set the retrieval method.
     */
    request_origin?: RequestOrigin | null;
    /**
     * The outreach ID.
     */
    outreach_id?: string | null;
    /**
     * The chart ID.
     */
    chart_id?: number | null;
    /**
     * The CDR document UUID.
     */
    cdr_document_id?: string | null;
    /**
     * The maximum scheduled date of the project.
     */
    max_scheduled_date?: string | null;
    /**
     * The display ID of the record request generated by Switchboard. To be consolidated with reference_id.
     */
    record_request_display_id?: string | null;
    /**
     * The display ID of the retrieval target generated by Switchboard. To be consolidated with reference_id.
     */
    retrieval_target_display_id?: string | null;
    /**
     * The display ID for the provider package.
     */
    provider_package_display_id?: string | null;
    /**
     * The unified group ID of the data coordinate. (cf_outreach_id or provider_package_display_id)
     */
    group_id?: string | null;
    /**
     * The unified request ID of the data coordinate. (cf_chart_id or reference_id)
     */
    request_id?: string | null;
    /**
     * The CDR UUID for the provider package.
     */
    provider_package_cdr_uuid?: string | null;
    /**
     * The last updated timestamp from DEDA.
     */
    deda_updated_at?: string | null;
    readonly practitioner_display_first_name: string | null;
    readonly practitioner_display_last_name: string | null;
};

export type PydanticProviderVerificationDisplay = {
    /**
     * The primary key ID of the data coordinate.
     */
    pk_id: number;
    /**
     * The health system associated with the provider.
     */
    health_system_id: string;
    /**
     * The provider's first name.
     */
    provider_first_name?: string | null;
    /**
     * The provider's last name.
     */
    provider_last_name?: string | null;
    /**
     * States whether the provider is verified or not.
     */
    is_verified: boolean;
    /**
     * The date and time the record was created.
     */
    created_at: string;
    /**
     * The date and time the record was last updated.
     */
    updated_at: string;
    /**
     * The UUID of the user who last modified the record.
     */
    last_modified_by_user_uuid: string;
    /**
     * The first name of the user who last modified the record.
     */
    user_first_name?: string | null;
    /**
     * The last name of the user who last modified the record.
     */
    user_last_name?: string | null;
    /**
     * The email address of the user who last modified the record.
     */
    user_email_address?: string | null;
};

export type PydanticQualityCheck = {
    /**
     * The primary key ID of the quality check.
     */
    pk_id: number;
    /**
     * The tenant UUID associated with the quality check.
     */
    tenant_uuid: string;
    /**
     * The data coordinate primary key ID associated with the quality check.
     */
    data_coordinate_pk_id: number;
    /**
     * The tracking ID of the quality check.
     */
    tracking_id?: string | null;
    /**
     * The CDR document location of the quality check records.
     */
    document_location?: string | null;
    /**
     * The status of quality check fulfillment.
     */
    status?: StatusEnum | null;
    /**
     * The status message of the quality check fulfillment.
     */
    status_message?: string | null;
    /**
     * If the user approved/denied the quality check.
     */
    approved?: boolean | null;
    /**
     * User feedback for the quality check.
     */
    feedback?: Array<RejectReasonsEnum> | null;
    /**
     * User feedback comment for the quality check.
     */
    feedback_comment?: string | null;
    /**
     * The user email associated with the quality check feedback.
     */
    feedback_email?: string | null;
    /**
     * The DVer email that triggered the quality check.
     */
    owner_email?: string | null;
    /**
     * The datetime the quality check record was created.
     */
    created_at: string;
    /**
     * The datetime the quality check record was last updated.
     */
    updated_at: string;
    /**
     * The datetime the quality check finished fulfillment (for both success/failure).
     */
    completed_at?: string | null;
};

export type PydanticSmartOutreach = {
    /**
     * The primary key ID of the smart outreach record.
     */
    pk_id: number;
    /**
     * The tenant UUID associated with the smart outreach record.
     */
    tenant_uuid: string;
    /**
     * The name of the rule associated with the smart outreach record.
     */
    rule_name: RuleEnum;
    /**
     * The datetime the smart outreach rule was last checked.
     */
    last_checked_at: string;
    /**
     * The datetime the smart outreach rule is deferred until.
     */
    defer_until?: string | null;
    /**
     * The status of the smart outreach rule.
     */
    status: SmartOutreachStatusEnum;
    /**
     * Additional metadata associated with the smart outreach rule.
     */
    rule_metadata?: {
    [key: string]: unknown;
} | null;
    /**
     * The datetime the smart outreach rule was created.
     */
    created_at: string;
    /**
     * The datetime the smart outreach rule was last updated.
     */
    updated_at: string;
};

/**
 * Represents a group of single uploads for a chart in RM Standard.
 */
export type PydanticStandardSingleUpload = {
    /**
     * The uploads_master uuid.
     */
    upload_master_uuid: string;
    /**
     * The standard single upload uuid.
     */
    standard_single_upload_uuid: string;
    /**
     * The tenant uuid.
     */
    tenant_uuid: string;
    /**
     * The data coordinate of the upload group.
     */
    data_coordinate: PydanticDataCoordinate;
    /**
     * The created date of the upload group.
     */
    created_at: string;
    /**
     * The files uploaded.
     */
    files?: Array<FileUploadEntry>;
};

export type RMFileUploadStatus = 'UPLOADED_S3' | 'UPLOADING_AZURE_FILESHARE' | 'UPLOADING_AZURE_FILESHARE_FAILED' | 'UPLOADED_AZURE_FILESHARE' | 'FILE_CONVERSION_FAILED' | 'FILE_MERGING_FAILED' | 'UPLOADING_CDR' | 'UPLOADING_CDR_FAILED' | 'UPLOADED_CDR' | 'UPLOADING_CHARTFINDER' | 'UPLOADING_CHARTFINDER_FAILED' | 'UPLOADED_CHARTFINDER' | 'UPLOADING_HUB_FAILED' | 'UPLOADING_HUB' | 'UPLOADED_HUB' | 'UPLOADING_SWITCHBOARD' | 'UPLOADED_SWITCHBOARD' | 'UPLOADING_SWITCHBOARD_FAILED' | 'AI_PROCESSING_SUCCESSFUL' | 'AI_PROCESSING_FAILED' | 'AI_RESULT_READY' | 'SENT_FOR_AI_PROCESSING';

export const RMFileUploadStatus = {
    UPLOADED_S3: 'UPLOADED_S3',
    UPLOADING_AZURE_FILESHARE: 'UPLOADING_AZURE_FILESHARE',
    UPLOADING_AZURE_FILESHARE_FAILED: 'UPLOADING_AZURE_FILESHARE_FAILED',
    UPLOADED_AZURE_FILESHARE: 'UPLOADED_AZURE_FILESHARE',
    FILE_CONVERSION_FAILED: 'FILE_CONVERSION_FAILED',
    FILE_MERGING_FAILED: 'FILE_MERGING_FAILED',
    UPLOADING_CDR: 'UPLOADING_CDR',
    UPLOADING_CDR_FAILED: 'UPLOADING_CDR_FAILED',
    UPLOADED_CDR: 'UPLOADED_CDR',
    UPLOADING_CHARTFINDER: 'UPLOADING_CHARTFINDER',
    UPLOADING_CHARTFINDER_FAILED: 'UPLOADING_CHARTFINDER_FAILED',
    UPLOADED_CHARTFINDER: 'UPLOADED_CHARTFINDER',
    UPLOADING_HUB_FAILED: 'UPLOADING_HUB_FAILED',
    UPLOADING_HUB: 'UPLOADING_HUB',
    UPLOADED_HUB: 'UPLOADED_HUB',
    UPLOADING_SWITCHBOARD: 'UPLOADING_SWITCHBOARD',
    UPLOADED_SWITCHBOARD: 'UPLOADED_SWITCHBOARD',
    UPLOADING_SWITCHBOARD_FAILED: 'UPLOADING_SWITCHBOARD_FAILED',
    AI_PROCESSING_SUCCESSFUL: 'AI_PROCESSING_SUCCESSFUL',
    AI_PROCESSING_FAILED: 'AI_PROCESSING_FAILED',
    AI_RESULT_READY: 'AI_RESULT_READY',
    SENT_FOR_AI_PROCESSING: 'SENT_FOR_AI_PROCESSING'
} as const;

export type RMFileUploadType = 'BASIC_SINGLE' | 'BASIC_BULK' | 'STANDARD_SINGLE' | 'STANDARD_BULK';

export const RMFileUploadType = {
    BASIC_SINGLE: 'BASIC_SINGLE',
    BASIC_BULK: 'BASIC_BULK',
    STANDARD_SINGLE: 'STANDARD_SINGLE',
    STANDARD_BULK: 'STANDARD_BULK'
} as const;

export type RRAFilter = {
    exclude_idsb_digital_failed_or_processing?: boolean | null;
    exclude_non_completed_digital_connections?: boolean | null;
};

export type RejectReasonsEnum = 'The PDF is missing information that would be manually pulled for the request.' | 'The PDF includes information that would not be manually pulled for the request.' | 'Other';

export const RejectReasonsEnum = {
    THE_PDF_IS_MISSING_INFORMATION_THAT_WOULD_BE_MANUALLY_PULLED_FOR_THE_REQUEST_: 'The PDF is missing information that would be manually pulled for the request.',
    THE_PDF_INCLUDES_INFORMATION_THAT_WOULD_NOT_BE_MANUALLY_PULLED_FOR_THE_REQUEST_: 'The PDF includes information that would not be manually pulled for the request.',
    OTHER: 'Other'
} as const;

/**
 * Outreach IDs for chases about to be flipped to manual outreach.
 */
export type RequestManagerOutreachNotificationsDataResponse = {
    /**
     * Key: Request ID, Value: dict containing 'due_date' and 'request_origin'
     */
    group_ids_data?: {
        [key: string]: {
            [key: string]: (string);
        };
    };
    /**
     * Request ids and their associated due dates and request origins e.g. { 'R1234': {'due_date': '10-05-2025', 'request_origin': 'CHART_FINDER' }
     */
    request_ids_data?: {
        [key: string]: {
            [key: string]: (string);
        };
    };
};

/**
 * RM Retrieval Types.
 */
export type RequestManagerRetrievalMethod = 'REQUEST_MANAGER_DIRECT' | 'REQUEST_MANAGER_TRADITIONAL' | 'DIGITAL_HEALTH_JUMP' | 'DIGITAL_FHIR_WORKER' | 'DIGITAL_VENDOR_DIRECT' | 'TRADITIONAL_MANUAL' | 'TRADITIONAL_ONSITE' | 'EMBEDDED' | 'OTHER' | 'DIGITAL_CONNECTIONS';

/**
 * RM Retrieval Types.
 */
export const RequestManagerRetrievalMethod = {
    REQUEST_MANAGER_DIRECT: 'REQUEST_MANAGER_DIRECT',
    REQUEST_MANAGER_TRADITIONAL: 'REQUEST_MANAGER_TRADITIONAL',
    DIGITAL_HEALTH_JUMP: 'DIGITAL_HEALTH_JUMP',
    DIGITAL_FHIR_WORKER: 'DIGITAL_FHIR_WORKER',
    DIGITAL_VENDOR_DIRECT: 'DIGITAL_VENDOR_DIRECT',
    TRADITIONAL_MANUAL: 'TRADITIONAL_MANUAL',
    TRADITIONAL_ONSITE: 'TRADITIONAL_ONSITE',
    EMBEDDED: 'EMBEDDED',
    OTHER: 'OTHER',
    DIGITAL_CONNECTIONS: 'DIGITAL_CONNECTIONS'
} as const;

/**
 * RM Retrieval Status.
 */
export type RequestManagerRetrievalStatus = 'PENDING_OPEN' | 'OPEN' | 'PROCESSING' | 'COMPLETED' | 'CANCELLED' | 'FAILED' | 'INTERNAL_HOLDING' | 'NOT_YET_RETRIEVED' | 'DELETED' | 'PAYMENT_REQUESTED';

/**
 * RM Retrieval Status.
 */
export const RequestManagerRetrievalStatus = {
    PENDING_OPEN: 'PENDING_OPEN',
    OPEN: 'OPEN',
    PROCESSING: 'PROCESSING',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    FAILED: 'FAILED',
    INTERNAL_HOLDING: 'INTERNAL_HOLDING',
    NOT_YET_RETRIEVED: 'NOT_YET_RETRIEVED',
    DELETED: 'DELETED',
    PAYMENT_REQUESTED: 'PAYMENT_REQUESTED'
} as const;

/**
 * RM Sort Options.
 */
export type RequestManagerSortOption = 'patient_name' | 'due_date';

/**
 * RM Sort Options.
 */
export const RequestManagerSortOption = {
    PATIENT_NAME: 'patient_name',
    DUE_DATE: 'due_date'
} as const;

/**
 * Origin of RM requests
 */
export type RequestOrigin = 'IDSB' | 'CHART_FINDER' | 'HUB' | 'IDSB_V2';

/**
 * Origin of RM requests
 */
export const RequestOrigin = {
    IDSB: 'IDSB',
    CHART_FINDER: 'CHART_FINDER',
    HUB: 'HUB',
    IDSB_V2: 'IDSB_V2'
} as const;

export type RequesterType = 'attorney' | 'datavant' | 'disability' | 'continuing_care' | 'copya' | 'copyi' | 'facility' | 'government' | 'insurance' | 'patient' | 'payd' | 'payi' | 'pro' | 'fac';

export const RequesterType = {
    ATTORNEY: 'attorney',
    DATAVANT: 'datavant',
    DISABILITY: 'disability',
    CONTINUING_CARE: 'continuing_care',
    COPYA: 'copya',
    COPYI: 'copyi',
    FACILITY: 'facility',
    GOVERNMENT: 'government',
    INSURANCE: 'insurance',
    PATIENT: 'patient',
    PAYD: 'payd',
    PAYI: 'payi',
    PRO: 'pro',
    FAC: 'fac'
} as const;

export type RerouteUpsertInput = {
    df_health_system_id?: string | null;
    df_master_address_key?: string | null;
    df_request_uuid?: string | null;
    cf_outreach_id?: number | null;
};

export type RuleEnum = 'RULE_INACTIVE_PROVIDER' | 'RULE_RRA_IMPL' | 'RULE_ROLLOUT_PHASE' | 'RULE_THROUGHPUT_SUPPRESSION';

export const RuleEnum = {
    RULE_INACTIVE_PROVIDER: 'RULE_INACTIVE_PROVIDER',
    RULE_RRA_IMPL: 'RULE_RRA_IMPL',
    RULE_ROLLOUT_PHASE: 'RULE_ROLLOUT_PHASE',
    RULE_THROUGHPUT_SUPPRESSION: 'RULE_THROUGHPUT_SUPPRESSION'
} as const;

export type SingleFileUploadRequest = {
    files: Array<SingleFileUploadRequestFile>;
    chart_id?: number | null;
    record_request_display_id?: string | null;
    chase_uuid?: string | null;
    file_type?: RMFileUploadType | null;
    provider_package_display_id?: string | null;
    ai_matched?: boolean | null;
};

export type SingleFileUploadRequestFile = {
    uuid: string;
    file_name: string;
    file_path: string;
    file_size: string;
    user_uuid?: string | null;
    provider_specified_file_name?: string | null;
    cdr_uuid?: string | null;
};

/**
 * Fields that comprise a single upload.
 */
export type SingleUpload = {
    chart_id: string;
    files: Array<SingleUploadFile>;
    num_files: number;
    updated_date: string;
    tenant_uuid?: string | null;
    chase_uuid?: string | null;
};

export type SingleUploadFile = {
    file_name: string;
    file_size: string;
    update_date: string;
    user_uuid?: string | null;
    provider_specified_file_name?: string | null;
    cdr_uuid?: string | null;
};

export type SmartOutreachCreateOrUpdateRequest = {
    /**
     * The tenant UUID the smart outreach record is for.
     */
    tenant_uuid: string;
    /**
     * The name of the rule associated with the smart outreach record.
     */
    rule_name: RuleEnum;
    /**
     * The status of the smart outreach rule.
     */
    status: SmartOutreachStatusEnum;
    /**
     * Additional metadata associated with the smart outreach rule.
     */
    metadata?: {
    [key: string]: unknown;
} | null;
    /**
     * The datetime the smart outreach rule is deferred until.
     */
    defer_until?: string | null;
};

export type SmartOutreachStatusEnum = 'EXECUTED' | 'SKIPPED' | 'DEFERRED';

export const SmartOutreachStatusEnum = {
    EXECUTED: 'EXECUTED',
    SKIPPED: 'SKIPPED',
    DEFERRED: 'DEFERRED'
} as const;

export type StandardSingleUploadQueueRequest = {
    filters: StandardSingleUploadSearchFilters;
    limit?: number | null;
    offset?: number | null;
    include_total?: boolean | null;
};

export type StandardSingleUploadQueueResponse = {
    total: number;
    uploads: Array<PydanticStandardSingleUpload>;
};

export type StandardSingleUploadSearchFilters = {
    tenant_uuid?: string | null;
    upload_master_uuid?: string | null;
    upload_uuid?: string | null;
    global_search?: string | null;
    upload_date_start?: string | null;
    upload_date_end?: string | null;
};

export type StandardSingleUploadWithPatientInfo = {
    uuid: string;
    master_upload_id: number;
    files: Array<File>;
    created_at: string;
    updated_at?: string | null;
    outreach_id?: number | null;
    patient_first_name?: string | null;
    patient_last_name?: string | null;
    patient_date_of_birth?: string | null;
    chart_id?: number | null;
    tenant_uuid?: string | null;
    record_request_display_id?: string | null;
    provider_package_display_id?: string | null;
    data_coord?: number | null;
    num_files?: number | null;
};

export type StatusEnum = 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';

export const StatusEnum = {
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
} as const;

export type UpdateDigitalEncounterFeedback = {
    /**
     * Id of the encounter feedback entry
     */
    pk_id: number;
    /**
     * Whether the encounter type is active for autofulfillment
     */
    active: boolean;
};

export type UpdateDigitalScannedDocumentFeedback = {
    /**
     * Id of the scanned document feedback entry
     */
    pk_id: number;
    /**
     * Whether the document category is active for autofulfillment
     */
    active: boolean;
};

export type UpdateFileUploadParams = {
    file_upload_uuid: string;
    new_file_status: RMFileUploadStatus;
    new_file_status_metadata?: FileUploadStatusMetadata | null;
    cdr_uuid?: string | null;
};

export type UpdateIDSBQADataCoordinateRequest = {
    status: "FAILED" | "COMPLETED";
    cdr_document_id: string;
};

export type UpsertIDSBDummyDataCoordinateRequest = {
    chart_tracking_id: number;
    df_health_system_id: string;
    df_master_address_key?: string | null;
};

export type UpsertIDSBRRAMLDataCoordinateRequest = {
    idsb_request_id: number;
    status?: "PROCESSING" | "COMPLETED" | "FAILED" | null;
    cdr_document_id?: string | null;
    retrieval_method?: "DIGITAL_FHIR_WORKER" | "DIGITAL_HEALTH_JUMP" | "DIGITAL_CONNECTIONS" | null;
    df_health_system_id?: string | null;
    requester_type?: RequesterType | null;
    requester_display_name?: string | null;
    primary_reason?: PrimaryReason | null;
    dos_start_date?: string | null;
    dos_end_date?: string | null;
    patient_first_name?: string | null;
    patient_last_name?: string | null;
    patient_sex?: Gender | null;
    patient_date_of_birth?: string | null;
    practitioner_first_name?: string | null;
    practitioner_last_name?: string | null;
    project_due_date?: string | null;
    cf_chart_id?: number | null;
};

export type UpsertSuccessAiMatchRequest = {
    reference_id: string;
    created_at: string;
    group_id?: string | null;
    original_file_upload_uuids?: Array<(string)> | null;
    original_cdr_uuids?: Array<(string)> | null;
    upload_origin?: BulkUploadAiProcessingUploadOriginEnum | null;
};

export type ValidationError = {
    loc: Array<(string | number)>;
    msg: string;
    type: string;
    input?: unknown;
    ctx?: {
        [key: string]: unknown;
    };
};

export type HealthHealthGetResponse = unknown;

export type PersistSingleUploadByTenantIdBasicStandardSingleTenantUuidPostData = {
    requestBody: SingleFileUploadRequest;
    tenantUuid: string;
};

export type PersistSingleUploadByTenantIdBasicStandardSingleTenantUuidPostResponse = FileUpload;

export type RepushFilesForChartBasicRepushSinglePostData = {
    requestBody: ChartRepushRequest;
};

export type RepushFilesForChartBasicRepushSinglePostResponse = ChartRepushResult;

export type RepushFilesForOutreachBasicRepushBulkPostData = {
    requestBody: OutreachRepushRequest;
};

export type RepushFilesForOutreachBasicRepushBulkPostResponse = OutreachRepushResult;

export type GetDataCoordinateForRmQueueV2DataCoordinatesPostData = {
    requestBody: DataCoordinateQueueRequest;
};

export type GetDataCoordinateForRmQueueV2DataCoordinatesPostResponse = DataCoordinateQueueResponse;

export type UpdateDataCoordinatesV2DataCoordinatesPatchData = {
    requestBody: DataCoordinateUpdateRequest;
};

export type UpdateDataCoordinatesV2DataCoordinatesPatchResponse = DataCoordinateQueueResponse;

export type GetDataCoordinateForRmQueueInternalV2DataCoordinatesInternalPostData = {
    requestBody: DataCoordinateQueueRequestInternal;
};

export type GetDataCoordinateForRmQueueInternalV2DataCoordinatesInternalPostResponse = DataCoordinateQueueResponse;

export type UpdateDataCoordinatesV2DataCoordinatesInternalPatchData = {
    requestBody: DataCoordinateUpdateRequestInternal;
};

export type UpdateDataCoordinatesV2DataCoordinatesInternalPatchResponse = DataCoordinateQueueResponse;

export type GetDataCoordinatesForDeniedProvidersV2DataCoordinatesDeniedProvidersPostData = {
    requestBody: DataCoordinateHealthSystemFilters;
};

export type GetDataCoordinatesForDeniedProvidersV2DataCoordinatesDeniedProvidersPostResponse = DataCoordinateForDeniedProvidersResponse;

export type GetDataCoordinateCountForRmQueueV2DataCoordinatesCountPostData = {
    requestBody: DataCoordinateCountRequest;
};

export type GetDataCoordinateCountForRmQueueV2DataCoordinatesCountPostResponse = number;

export type ListPractitionersFromDataCoordinatesV2DataCoordinatesPractitionersPostData = {
    requestBody: PractitionerInputRequest;
};

export type ListPractitionersFromDataCoordinatesV2DataCoordinatesPractitionersPostResponse = Array<PractitionerName>;

export type GetEmailNotificationsDataV2DataCoordinatesEmailNotificationDataPostData = {
    requestBody: EmailNotificationsDataRequest;
};

export type GetEmailNotificationsDataV2DataCoordinatesEmailNotificationDataPostResponse = DataCoordinateEmailNotificationResponse;

export type GetEmailNotificationsDataV2DataCoordinatesOutreachNotificationDataPostData = {
    requestBody: OutreachNotificationsDataRequest;
};

export type GetEmailNotificationsDataV2DataCoordinatesOutreachNotificationDataPostResponse = RequestManagerOutreachNotificationsDataResponse;

export type BatchUpsertIdsbDummyDataCoordinatesV2DataCoordinatesBatchIdsbDummyPostData = {
    requestBody: Array<UpsertIDSBDummyDataCoordinateRequest>;
};

export type BatchUpsertIdsbDummyDataCoordinatesV2DataCoordinatesBatchIdsbDummyPostResponse = void;

export type BatchUpsertIdsbRraMlDataCoordinatesV2DataCoordinatesBatchIdsbRraMlPostData = {
    requestBody: Array<UpsertIDSBRRAMLDataCoordinateRequest>;
};

export type BatchUpsertIdsbRraMlDataCoordinatesV2DataCoordinatesBatchIdsbRraMlPostResponse = void;

export type BatchUpdateIdsbQaDataCoordinatesV2DataCoordinatesBatchIdsbQaPostData = {
    requestBody: Array<UpdateIDSBQADataCoordinateRequest>;
};

export type BatchUpdateIdsbQaDataCoordinatesV2DataCoordinatesBatchIdsbQaPostResponse = void;

export type ManualImportDataCoordinatesV2DataCoordinatesManualImportPostData = {
    requestBody: ManualImportDataCoordinatesRequest;
};

export type ManualImportDataCoordinatesV2DataCoordinatesManualImportPostResponse = ManualImportDataCoordinatesResponse;

export type GetDataCoordinateIdentifiersV2DataCoordinatesPhoneFaxProviderPackageDisplayIdGetData = {
    providerPackageDisplayId: string;
};

export type GetDataCoordinateIdentifiersV2DataCoordinatesPhoneFaxProviderPackageDisplayIdGetResponse = DataCoordinateIdentifiersResponse;

export type SearchGroupIdsV2DataCoordinatesGroupIdSearchPostData = {
    requestBody: GroupIdSearchRequest;
};

export type SearchGroupIdsV2DataCoordinatesGroupIdSearchPostResponse = GroupIdSearchResponse;

export type ExpireDataCoordinatesForTenantV2DataCoordinatesInternalExpirePostData = {
    requestBody: DataCoordinateExpireRequest;
};

export type ExpireDataCoordinatesForTenantV2DataCoordinatesInternalExpirePostResponse = DataCoordinateExpireAccepted;

export type GetTenantSmartOutreachRecordsSmartOutreachGetData = {
    tenantUuid: string;
};

export type GetTenantSmartOutreachRecordsSmartOutreachGetResponse = Array<PydanticSmartOutreach>;

export type UpsertSmartOutreachRecordSmartOutreachPostData = {
    requestBody: SmartOutreachCreateOrUpdateRequest;
};

export type UpsertSmartOutreachRecordSmartOutreachPostResponse = PydanticSmartOutreach;

export type GetProviderVerificationsProviderVerificationHealthSystemIdGetData = {
    healthSystemId: string;
    includeUserInfo?: boolean;
};

export type GetProviderVerificationsProviderVerificationHealthSystemIdGetResponse = ProviderVerificationGetResponse;

export type CreateProviderVerificationProviderVerificationPostData = {
    requestBody: ProviderVerificationCreateRequest;
};

export type CreateProviderVerificationProviderVerificationPostResponse = ProviderVerificationResponse;

export type UpdateProviderVerificationProviderVerificationPkIdPatchData = {
    pkId: number;
    requestBody: ProviderVerificationUpdateRequest;
};

export type UpdateProviderVerificationProviderVerificationPkIdPatchResponse = ProviderVerificationResponse;

export type SoftDeleteProviderVerificationProviderVerificationPkIdDeleteData = {
    healthSystemId: string;
    lastModifiedByUserUuid: string;
    pkId: number;
};

export type SoftDeleteProviderVerificationProviderVerificationPkIdDeleteResponse = void;

export type GetDigitalQualityChecksByTenantDigitalQcGetData = {
    tenantUuid: string;
};

export type GetDigitalQualityChecksByTenantDigitalQcGetResponse = Array<PydanticQualityCheck>;

export type CreateDigitalQualityChecksDigitalQcPostData = {
    requestBody: DigitalQCCreateRequest;
};

export type CreateDigitalQualityChecksDigitalQcPostResponse = Array<PydanticQualityCheck>;

export type UpdateDigitalQualityCheckStatusDigitalQcStatusPatchData = {
    requestBody: Array<DigitalQCBulkUpdateStatus>;
};

export type UpdateDigitalQualityCheckStatusDigitalQcStatusPatchResponse = DigitalQCBulkUpdateReponse;

export type UpdateDigitalQualityCheckDigitalQcBulkUpdatePatchData = {
    requestBody: DigitalQCBulkUpdateRequest;
};

export type UpdateDigitalQualityCheckDigitalQcBulkUpdatePatchResponse = DigitalQCBulkUpdateReponse;

export type CreateAddressFeedbackDigitalAddressFeedbackPostData = {
    requestBody: CreateAddressFeedbackRequest;
};

export type CreateAddressFeedbackDigitalAddressFeedbackPostResponse = unknown;

export type CreateAddressFeedbackInRosterDigitalAddressFeedbackActivatePostData = {
    requestBody: CreateAddressFeedbackSnowflakeRequest;
};

export type CreateAddressFeedbackInRosterDigitalAddressFeedbackActivatePostResponse = unknown;

export type CreateDigitalAgreementDigitalAgreementPostData = {
    requestBody: CreateDigitalAgreement;
};

export type CreateDigitalAgreementDigitalAgreementPostResponse = DigitalAgreement;

export type GetEncounterFeedbackByTenantUuidDigitalEncounterFeedbackTenantUuidGetData = {
    encounterNameSearch?: string | null;
    /**
     * Page number
     */
    page?: number;
    /**
     * Page size
     */
    size?: number;
    tenantUuid: string;
};

export type GetEncounterFeedbackByTenantUuidDigitalEncounterFeedbackTenantUuidGetResponse = Page_DigitalEncounterFeedback_;

export type UpdateEncounterFeedbackDigitalEncounterFeedbackTenantUuidPatchData = {
    requestBody: Array<UpdateDigitalEncounterFeedback>;
    tenantUuid: string;
};

export type UpdateEncounterFeedbackDigitalEncounterFeedbackTenantUuidPatchResponse = void;

export type CreateEncounterFeedbackDigitalEncounterFeedbackPostData = {
    requestBody: CreateDigitalEncounterFeedback;
};

export type CreateEncounterFeedbackDigitalEncounterFeedbackPostResponse = Array<DigitalEncounterFeedback>;

export type BulkCreateEncounterFeedbackDigitalEncounterFeedbackBulkPostData = {
    requestBody: CreateDigitalEncounterFeedback;
};

export type BulkCreateEncounterFeedbackDigitalEncounterFeedbackBulkPostResponse = unknown;

export type GetScannedDocumentFeedbackByTenantUuidDigitalScannedDocumentFeedbackTenantUuidGetData = {
    documentCategorySearch?: string | null;
    /**
     * Page number
     */
    page?: number;
    /**
     * Page size
     */
    size?: number;
    tenantUuid: string;
};

export type GetScannedDocumentFeedbackByTenantUuidDigitalScannedDocumentFeedbackTenantUuidGetResponse = Page_DigitalScannedDocumentFeedback_;

export type UpdateScannedDocumentFeedbackDigitalScannedDocumentFeedbackTenantUuidPatchData = {
    requestBody: Array<UpdateDigitalScannedDocumentFeedback>;
    tenantUuid: string;
};

export type UpdateScannedDocumentFeedbackDigitalScannedDocumentFeedbackTenantUuidPatchResponse = void;

export type CreateScannedDocumentFeedbackDigitalScannedDocumentFeedbackPostData = {
    requestBody: CreateDigitalScannedDocumentFeedback;
};

export type CreateScannedDocumentFeedbackDigitalScannedDocumentFeedbackPostResponse = Array<DigitalScannedDocumentFeedback>;

export type BulkCreateScannedDocumentFeedbackDigitalScannedDocumentFeedbackBulkPostData = {
    requestBody: CreateDigitalScannedDocumentFeedback;
};

export type BulkCreateScannedDocumentFeedbackDigitalScannedDocumentFeedbackBulkPostResponse = unknown;

export type UpdateDigitalOnboardingStatusDigitalOnboardingStatusPostData = {
    canRegress?: boolean | null;
    status: NonEmbeddedImplementationStatus;
    tenantUuid: string;
};

export type UpdateDigitalOnboardingStatusDigitalOnboardingStatusPostResponse = unknown;

export type RerouteOutreachReroutePostData = {
    requestBody: RerouteUpsertInput;
};

export type RerouteOutreachReroutePostResponse = void;

export type PersistSingleUploadByProviderPackageDisplayIdHubBasicSingleProviderPackageDisplayIdPostData = {
    providerPackageDisplayId: string;
    requestBody: SingleFileUploadRequest;
};

export type PersistSingleUploadByProviderPackageDisplayIdHubBasicSingleProviderPackageDisplayIdPostResponse = FileUpload;

export type MemoizeHubBasicBulkUploadForProviderPackageDisplayIdHubBasicBulkProviderPackageDisplayIdPostData = {
    /**
     * The provider package display id associated with the bulk upload
     */
    providerPackageDisplayId: string;
    requestBody: BulkUploadForOutreachRequest;
};

export type MemoizeHubBasicBulkUploadForProviderPackageDisplayIdHubBasicBulkProviderPackageDisplayIdPostResponse = FileUpload;

export type PersistSingleUploadByTenantIdHubStandardSingleTenantUuidPostData = {
    requestBody: SingleFileUploadRequest;
    tenantUuid: string;
};

export type PersistSingleUploadByTenantIdHubStandardSingleTenantUuidPostResponse = FileUpload;

export type MemoizeBulkUploadHubStandardBulkTenantIdPostData = {
    requestBody: BulkUploadRequest;
    /**
     * The tenant ID associated with the bulk upload
     */
    tenantId: string;
};

export type MemoizeBulkUploadHubStandardBulkTenantIdPostResponse = BulkUpload;

export type GetBulkByProviderPackageDisplayIdHubProviderPackageDisplayIdProviderPackageDisplayIdGetData = {
    /**
     * The provider package display id associated with the bulk upload(s)
     */
    providerPackageDisplayId: string;
};

export type GetBulkByProviderPackageDisplayIdHubProviderPackageDisplayIdProviderPackageDisplayIdGetResponse = Array<FileUpload>;

export type PersistSingleUploadByTenantIdSwitchboardStandardSingleTenantUuidPostData = {
    requestBody: SingleFileUploadRequest;
    tenantUuid: string;
};

export type PersistSingleUploadByTenantIdSwitchboardStandardSingleTenantUuidPostResponse = FileUpload;

export type DedaPayerRetrievalRequestManagerResultSendSuccessfulDedaPayerRetrievalRequestManagerResultSendSuccessfulPostData = {
    requestBody: DedaSuccessfulEventRequest;
};

export type DedaPayerRetrievalRequestManagerResultSendSuccessfulDedaPayerRetrievalRequestManagerResultSendSuccessfulPostResponse = unknown;

export type DedaPayerRetrievalRequestManagerResultSendUnsuccessfulDedaPayerRetrievalRequestManagerResultSendUnsuccessfulPostData = {
    requestBody: DedaUnsuccessfulEventRequest;
};

export type DedaPayerRetrievalRequestManagerResultSendUnsuccessfulDedaPayerRetrievalRequestManagerResultSendUnsuccessfulPostResponse = unknown;

export type GetProcessedResultByReferenceIdV2BulkUploadAiProcessedResultReferenceIdGetData = {
    referenceId: string;
};

export type GetProcessedResultByReferenceIdV2BulkUploadAiProcessedResultReferenceIdGetResponse = BulkUploadAiProcessedResult;

export type UpsertProcessedResultUuidsByReferenceIdAndDateV2BulkUploadAiProcessedResultSuccessPutData = {
    requestBody: UpsertSuccessAiMatchRequest;
};

export type UpsertProcessedResultUuidsByReferenceIdAndDateV2BulkUploadAiProcessedResultSuccessPutResponse = BulkUploadAiProcessedResult;

export type ProcessAiMatchFailedV2BulkUploadAiProcessedResultFailurePostData = {
    requestBody: PostFailedAiMatchRequest;
};

export type ProcessAiMatchFailedV2BulkUploadAiProcessedResultFailurePostResponse = BulkUploadAiProcessedResult;

export type UpdateFinalCdrUuidByReferenceIdV2BulkUploadAiProcessedResultUpdateFinalUuidsPatchData = {
    requestBody: PatchFinalUuidPayload;
};

export type UpdateFinalCdrUuidByReferenceIdV2BulkUploadAiProcessedResultUpdateFinalUuidsPatchResponse = BulkUploadAiProcessedResult;

export type GetProcessedResultsByDayV2BulkUploadAiProcessedResultByDayDayGetData = {
    day: string;
};

export type GetProcessedResultsByDayV2BulkUploadAiProcessedResultByDayDayGetResponse = Array<BulkUploadAiProcessedResult>;

export type PersistAiResultV2BulkUploadAiResultCdrUuidPatchData = {
    cdrUuid: string;
    requestBody: PatchAiRawResultPayload;
};

export type PersistAiResultV2BulkUploadAiResultCdrUuidPatchResponse = BulkUploadAiRawResult;

export type CreateAiResultV2BulkUploadAiResultPostData = {
    requestBody: CreateAiRawResultParams;
};

export type CreateAiResultV2BulkUploadAiResultPostResponse = BulkUploadAiRawResult;

export type GetAiResultsV2BulkUploadAiResultGetData = {
    /**
     * Filter by creation date (YYYY-MM-DD)
     */
    date?: string | null;
    /**
     * Filter by group ID
     */
    groupId?: string | null;
};

export type GetAiResultsV2BulkUploadAiResultGetResponse = Array<BulkUploadAiRawResult>;

export type RequestManagerUploadCountChasesRequestManagerUploadCountGetResponse = number | ErrorHTTPResponse;

export type UpdateHsIdChasesProviderHsIdBulkUpdatePatchData = {
    newHsId: string;
    oldHsId: string;
};

export type UpdateHsIdChasesProviderHsIdBulkUpdatePatchResponse = void;

export type UpdateMasterChasesBulkChasesProviderBulkPatchData = {
    requestBody: Body_update_master_chases_bulk_chases_provider_bulk_patch;
};

export type UpdateMasterChasesBulkChasesProviderBulkPatchResponse = void;

export type UpdateMasterChasesWithDataCoordinatePkIdsBulkChasesProviderBulkV2PatchData = {
    requestBody: Body_update_master_chases_with_data_coordinate_pk_ids_bulk_chases_provider_bulk_v2_patch;
};

export type UpdateMasterChasesWithDataCoordinatePkIdsBulkChasesProviderBulkV2PatchResponse = void;

export type UpdateMasterChasesChasesProviderMasterChaseUuidPatchData = {
    legacyIds?: string;
    masterChaseUuid: string;
    requestBody: MasterChaseUpdateRequest;
};

export type UpdateMasterChasesChasesProviderMasterChaseUuidPatchResponse = void;

export type CreateManualUploadFileManualUploadFilesPostData = {
    requestBody: ManualUploadFileRequest;
};

export type CreateManualUploadFileManualUploadFilesPostResponse = ManualUploadFile;

export type GetBulkUploadBulkUploadsTenantIdGetData = {
    bulkUploadId?: number | null;
    /**
     * The tenant UUID associated with the bulk upload(s)
     */
    tenantId: string;
};

export type GetBulkUploadBulkUploadsTenantIdGetResponse = Array<BulkUpload>;

export type MemoizeBulkUploadBulkUploadsTenantIdPostData = {
    requestBody: BulkUploadRequest;
    /**
     * The tenant ID associated with the bulk upload
     */
    tenantId: string;
};

export type MemoizeBulkUploadBulkUploadsTenantIdPostResponse = BulkUpload;

export type GetBulkByOutreachIdBulkUploadsOutreachOutreachIdGetData = {
    /**
     * The outreach ID associated with the bulk upload(s)
     */
    outreachId: number;
};

export type GetBulkByOutreachIdBulkUploadsOutreachOutreachIdGetResponse = Array<FileUpload>;

export type MemoizeRmBasicBulkUploadForOutreachBulkUploadsOutreachOutreachIdPostData = {
    /**
     * The outreach id associated with the bulk upload
     */
    outreachId: number;
    requestBody: BulkUploadForOutreachRequest;
};

export type MemoizeRmBasicBulkUploadForOutreachBulkUploadsOutreachOutreachIdPostResponse = FileUpload;

export type GetBulkUploadFileBulkUploadsFileFileUuidGetData = {
    /**
     * The UUID of the bulk uploaded file to retrieve
     */
    fileUuid: string;
};

export type GetBulkUploadFileBulkUploadsFileFileUuidGetResponse = BulkUploadFile;

export type UpdateBulkUploadFilesBulkUploadsFilePatchData = {
    requestBody: BulkUploadFilePatchRequest;
};

export type UpdateBulkUploadFilesBulkUploadsFilePatchResponse = BulkUploadFile;

export type GetUploadGroupByFileUuidBulkUploadsBulkUploadGroupFileUuidGetData = {
    /**
     * The UUID of the bulk uploaded child file
     */
    fileUuid: string;
};

export type GetUploadGroupByFileUuidBulkUploadsBulkUploadGroupFileUuidGetResponse = BulkUploadNoChildFiles;

export type GetSingleUploadsByOutreachIdBasicSingleOutreachIdGetData = {
    outreachId: string;
};

export type GetSingleUploadsByOutreachIdBasicSingleOutreachIdGetResponse = Array<SingleUpload>;

export type PersistSingleUploadByOutreachIdBasicSingleOutreachIdPostData = {
    outreachId: number;
    requestBody: SingleFileUploadRequest;
};

export type PersistSingleUploadByOutreachIdBasicSingleOutreachIdPostResponse = FileUpload;

export type UpdateFileStatusBasicStatusPatchData = {
    requestBody: UpdateFileUploadParams;
};

export type UpdateFileStatusBasicStatusPatchResponse = FileUpload;

export type PersistAiSingleUploadByOutreachIdBasicSingleAiOutreachIdPostData = {
    outreachId: number;
    requestBody: SingleFileUploadRequest;
};

export type PersistAiSingleUploadByOutreachIdBasicSingleAiOutreachIdPostResponse = FileUpload;

export type GetStandardSingleByTenantUuidBasicStandardSingleTenantUuidGetData = {
    tenantUuid: string;
};

export type GetStandardSingleByTenantUuidBasicStandardSingleTenantUuidGetResponse = Array<SingleUpload>;

export type GetBasicSingleUploadsByOutreachIdV2FileUploadBasicSingleGetData = {
    /**
     * The outreach ID to get the single uploads for.
     */
    outreachId: number;
};

export type GetBasicSingleUploadsByOutreachIdV2FileUploadBasicSingleGetResponse = Array<SingleUpload>;

export type GetBasicBulkUploadsByOutreachIdV2FileUploadBasicBulkGetData = {
    /**
     * The outreach ID to get the bulk uploads for.
     */
    outreachId: number;
};

export type GetBasicBulkUploadsByOutreachIdV2FileUploadBasicBulkGetResponse = Array<FileUploadEntry>;

export type GetSingleUploadsForRmStandardV2FileUploadStandardPostData = {
    requestBody: StandardSingleUploadQueueRequest;
};

export type GetSingleUploadsForRmStandardV2FileUploadStandardPostResponse = StandardSingleUploadQueueResponse;

export type GetSingleUploadsWithPatientInfoForRmStandardV2FileUploadStandardSingleUploadsTenantUuidGetData = {
    tenantUuid: string;
    /**
     * Narrow the result to a single upload, identified by the upload's confirmation number (standard_single_uploads.uuid). Still scoped to tenant_uuid, so this cannot be used to read another tenant's upload.
     */
    uploadUuid?: string | null;
};

export type GetSingleUploadsWithPatientInfoForRmStandardV2FileUploadStandardSingleUploadsTenantUuidGetResponse = Array<StandardSingleUploadWithPatientInfo>;

export type GetFileByUuidV2FileUploadGeneralFileFileUuidGetData = {
    fileUuid: string;
};

export type GetFileByUuidV2FileUploadGeneralFileFileUuidGetResponse = FileUploadEntry;

export type $OpenApiTs = {
    '/health': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
            };
        };
    };
    '/basic/standard/single/{tenant_uuid}': {
        post: {
            req: PersistSingleUploadByTenantIdBasicStandardSingleTenantUuidPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: FileUpload;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        get: {
            req: GetStandardSingleByTenantUuidBasicStandardSingleTenantUuidGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<SingleUpload>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/basic/repush-single': {
        post: {
            req: RepushFilesForChartBasicRepushSinglePostData;
            res: {
                /**
                 * Successful Response
                 */
                200: ChartRepushResult;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/basic/repush-bulk': {
        post: {
            req: RepushFilesForOutreachBasicRepushBulkPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: OutreachRepushResult;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/data-coordinates/': {
        post: {
            req: GetDataCoordinateForRmQueueV2DataCoordinatesPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: DataCoordinateQueueResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        patch: {
            req: UpdateDataCoordinatesV2DataCoordinatesPatchData;
            res: {
                /**
                 * Successful Response
                 */
                200: DataCoordinateQueueResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/data-coordinates/internal': {
        post: {
            req: GetDataCoordinateForRmQueueInternalV2DataCoordinatesInternalPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: DataCoordinateQueueResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        patch: {
            req: UpdateDataCoordinatesV2DataCoordinatesInternalPatchData;
            res: {
                /**
                 * Successful Response
                 */
                200: DataCoordinateQueueResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/data-coordinates/denied-providers': {
        post: {
            req: GetDataCoordinatesForDeniedProvidersV2DataCoordinatesDeniedProvidersPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: DataCoordinateForDeniedProvidersResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/data-coordinates/count': {
        post: {
            req: GetDataCoordinateCountForRmQueueV2DataCoordinatesCountPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: number;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/data-coordinates/practitioners': {
        post: {
            req: ListPractitionersFromDataCoordinatesV2DataCoordinatesPractitionersPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<PractitionerName>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/data-coordinates/email-notification-data': {
        post: {
            req: GetEmailNotificationsDataV2DataCoordinatesEmailNotificationDataPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: DataCoordinateEmailNotificationResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/data-coordinates/outreach-notification-data': {
        post: {
            req: GetEmailNotificationsDataV2DataCoordinatesOutreachNotificationDataPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: RequestManagerOutreachNotificationsDataResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/data-coordinates/batch-idsb-dummy': {
        post: {
            req: BatchUpsertIdsbDummyDataCoordinatesV2DataCoordinatesBatchIdsbDummyPostData;
            res: {
                /**
                 * Successful Response
                 */
                204: void;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/data-coordinates/batch-idsb-rra-ml': {
        post: {
            req: BatchUpsertIdsbRraMlDataCoordinatesV2DataCoordinatesBatchIdsbRraMlPostData;
            res: {
                /**
                 * Successful Response
                 */
                204: void;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/data-coordinates/batch-idsb-qa': {
        post: {
            req: BatchUpdateIdsbQaDataCoordinatesV2DataCoordinatesBatchIdsbQaPostData;
            res: {
                /**
                 * Successful Response
                 */
                204: void;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/data-coordinates/manual-import': {
        post: {
            req: ManualImportDataCoordinatesV2DataCoordinatesManualImportPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: ManualImportDataCoordinatesResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/data-coordinates/phone-fax/{provider_package_display_id}': {
        get: {
            req: GetDataCoordinateIdentifiersV2DataCoordinatesPhoneFaxProviderPackageDisplayIdGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: DataCoordinateIdentifiersResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/data-coordinates/group-id-search': {
        post: {
            req: SearchGroupIdsV2DataCoordinatesGroupIdSearchPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: GroupIdSearchResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/data-coordinates/internal/expire': {
        post: {
            req: ExpireDataCoordinatesForTenantV2DataCoordinatesInternalExpirePostData;
            res: {
                /**
                 * Successful Response
                 */
                202: DataCoordinateExpireAccepted;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/smart-outreach': {
        get: {
            req: GetTenantSmartOutreachRecordsSmartOutreachGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<PydanticSmartOutreach>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/smart-outreach/': {
        post: {
            req: UpsertSmartOutreachRecordSmartOutreachPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: PydanticSmartOutreach;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/provider-verification/{health_system_id}': {
        get: {
            req: GetProviderVerificationsProviderVerificationHealthSystemIdGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: ProviderVerificationGetResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/provider-verification/': {
        post: {
            req: CreateProviderVerificationProviderVerificationPostData;
            res: {
                /**
                 * Successful Response
                 */
                201: ProviderVerificationResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/provider-verification/{pk_id}': {
        patch: {
            req: UpdateProviderVerificationProviderVerificationPkIdPatchData;
            res: {
                /**
                 * Successful Response
                 */
                200: ProviderVerificationResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        delete: {
            req: SoftDeleteProviderVerificationProviderVerificationPkIdDeleteData;
            res: {
                /**
                 * Successful Response
                 */
                204: void;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/digital-qc': {
        get: {
            req: GetDigitalQualityChecksByTenantDigitalQcGetData;
            res: {
                /**
                 * Successful Response
                 */
                201: Array<PydanticQualityCheck>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/digital-qc/': {
        post: {
            req: CreateDigitalQualityChecksDigitalQcPostData;
            res: {
                /**
                 * Successful Response
                 */
                201: Array<PydanticQualityCheck>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/digital-qc/status': {
        patch: {
            req: UpdateDigitalQualityCheckStatusDigitalQcStatusPatchData;
            res: {
                /**
                 * Successful Response
                 */
                200: DigitalQCBulkUpdateReponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/digital-qc/bulk-update': {
        patch: {
            req: UpdateDigitalQualityCheckDigitalQcBulkUpdatePatchData;
            res: {
                /**
                 * Successful Response
                 */
                200: DigitalQCBulkUpdateReponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/digital-address-feedback/': {
        post: {
            req: CreateAddressFeedbackDigitalAddressFeedbackPostData;
            res: {
                /**
                 * Successful Response
                 */
                201: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/digital-address-feedback/activate': {
        post: {
            req: CreateAddressFeedbackInRosterDigitalAddressFeedbackActivatePostData;
            res: {
                /**
                 * Successful Response
                 */
                201: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/digital-agreement/': {
        post: {
            req: CreateDigitalAgreementDigitalAgreementPostData;
            res: {
                /**
                 * Successful Response
                 */
                201: DigitalAgreement;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/digital-encounter-feedback/{tenant_uuid}': {
        get: {
            req: GetEncounterFeedbackByTenantUuidDigitalEncounterFeedbackTenantUuidGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: Page_DigitalEncounterFeedback_;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        patch: {
            req: UpdateEncounterFeedbackDigitalEncounterFeedbackTenantUuidPatchData;
            res: {
                /**
                 * Successful Response
                 */
                204: void;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/digital-encounter-feedback/': {
        post: {
            req: CreateEncounterFeedbackDigitalEncounterFeedbackPostData;
            res: {
                /**
                 * Successful Response
                 */
                201: Array<DigitalEncounterFeedback>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/digital-encounter-feedback/bulk': {
        post: {
            req: BulkCreateEncounterFeedbackDigitalEncounterFeedbackBulkPostData;
            res: {
                /**
                 * Successful Response
                 */
                201: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/digital-scanned-document-feedback/{tenant_uuid}': {
        get: {
            req: GetScannedDocumentFeedbackByTenantUuidDigitalScannedDocumentFeedbackTenantUuidGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: Page_DigitalScannedDocumentFeedback_;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        patch: {
            req: UpdateScannedDocumentFeedbackDigitalScannedDocumentFeedbackTenantUuidPatchData;
            res: {
                /**
                 * Successful Response
                 */
                204: void;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/digital-scanned-document-feedback/': {
        post: {
            req: CreateScannedDocumentFeedbackDigitalScannedDocumentFeedbackPostData;
            res: {
                /**
                 * Successful Response
                 */
                201: Array<DigitalScannedDocumentFeedback>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/digital-scanned-document-feedback/bulk': {
        post: {
            req: BulkCreateScannedDocumentFeedbackDigitalScannedDocumentFeedbackBulkPostData;
            res: {
                /**
                 * Successful Response
                 */
                201: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/digital-onboarding-status/': {
        post: {
            req: UpdateDigitalOnboardingStatusDigitalOnboardingStatusPostData;
            res: {
                /**
                 * Successful Response
                 */
                201: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/reroute/': {
        post: {
            req: RerouteOutreachReroutePostData;
            res: {
                /**
                 * Successful Response
                 */
                204: void;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/hub/basic/single/{provider_package_display_id}': {
        post: {
            req: PersistSingleUploadByProviderPackageDisplayIdHubBasicSingleProviderPackageDisplayIdPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: FileUpload;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/hub/basic/bulk/{provider_package_display_id}': {
        post: {
            req: MemoizeHubBasicBulkUploadForProviderPackageDisplayIdHubBasicBulkProviderPackageDisplayIdPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: FileUpload;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/hub/standard/single/{tenant_uuid}': {
        post: {
            req: PersistSingleUploadByTenantIdHubStandardSingleTenantUuidPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: FileUpload;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/hub/standard/bulk/{tenant_id}': {
        post: {
            req: MemoizeBulkUploadHubStandardBulkTenantIdPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: BulkUpload;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/hub/provider_package_display_id/{provider_package_display_id}': {
        get: {
            req: GetBulkByProviderPackageDisplayIdHubProviderPackageDisplayIdProviderPackageDisplayIdGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<FileUpload>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/switchboard/standard/single/{tenant_uuid}': {
        post: {
            req: PersistSingleUploadByTenantIdSwitchboardStandardSingleTenantUuidPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: FileUpload;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/deda/payer-retrieval-request-manager-result/send-successful': {
        post: {
            req: DedaPayerRetrievalRequestManagerResultSendSuccessfulDedaPayerRetrievalRequestManagerResultSendSuccessfulPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/deda/payer-retrieval-request-manager-result/send-unsuccessful': {
        post: {
            req: DedaPayerRetrievalRequestManagerResultSendUnsuccessfulDedaPayerRetrievalRequestManagerResultSendUnsuccessfulPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/bulk-upload/ai-processed-result/{reference_id}': {
        get: {
            req: GetProcessedResultByReferenceIdV2BulkUploadAiProcessedResultReferenceIdGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: BulkUploadAiProcessedResult;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/bulk-upload/ai-processed-result/success': {
        put: {
            req: UpsertProcessedResultUuidsByReferenceIdAndDateV2BulkUploadAiProcessedResultSuccessPutData;
            res: {
                /**
                 * Successful Response
                 */
                200: BulkUploadAiProcessedResult;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/bulk-upload/ai-processed-result/failure': {
        post: {
            req: ProcessAiMatchFailedV2BulkUploadAiProcessedResultFailurePostData;
            res: {
                /**
                 * Successful Response
                 */
                201: BulkUploadAiProcessedResult;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/bulk-upload/ai-processed-result/update-final-uuids': {
        patch: {
            req: UpdateFinalCdrUuidByReferenceIdV2BulkUploadAiProcessedResultUpdateFinalUuidsPatchData;
            res: {
                /**
                 * Successful Response
                 */
                200: BulkUploadAiProcessedResult;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/bulk-upload/ai-processed-result/by-day/{day}': {
        get: {
            req: GetProcessedResultsByDayV2BulkUploadAiProcessedResultByDayDayGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<BulkUploadAiProcessedResult>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/bulk-upload/ai-result/{cdr_uuid}': {
        patch: {
            req: PersistAiResultV2BulkUploadAiResultCdrUuidPatchData;
            res: {
                /**
                 * Successful Response
                 */
                200: BulkUploadAiRawResult;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/bulk-upload/ai-result': {
        post: {
            req: CreateAiResultV2BulkUploadAiResultPostData;
            res: {
                /**
                 * Successful Response
                 */
                201: BulkUploadAiRawResult;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        get: {
            req: GetAiResultsV2BulkUploadAiResultGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<BulkUploadAiRawResult>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/chases/request-manager-upload-count': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: number | ErrorHTTPResponse;
            };
        };
    };
    '/chases/provider/hs-id-bulk-update': {
        patch: {
            req: UpdateHsIdChasesProviderHsIdBulkUpdatePatchData;
            res: {
                /**
                 * Successful Response
                 */
                204: void;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/chases/provider/bulk': {
        patch: {
            req: UpdateMasterChasesBulkChasesProviderBulkPatchData;
            res: {
                /**
                 * Successful Response
                 */
                204: void;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/chases/provider/bulk/v2': {
        patch: {
            req: UpdateMasterChasesWithDataCoordinatePkIdsBulkChasesProviderBulkV2PatchData;
            res: {
                /**
                 * Successful Response
                 */
                204: void;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/chases/provider/{master_chase_uuid}': {
        patch: {
            req: UpdateMasterChasesChasesProviderMasterChaseUuidPatchData;
            res: {
                /**
                 * Successful Response
                 */
                204: void;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/manual_upload_files': {
        post: {
            req: CreateManualUploadFileManualUploadFilesPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: ManualUploadFile;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/bulk_uploads/{tenant_id}': {
        get: {
            req: GetBulkUploadBulkUploadsTenantIdGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<BulkUpload>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        post: {
            req: MemoizeBulkUploadBulkUploadsTenantIdPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: BulkUpload;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/bulk_uploads/outreach/{outreach_id}': {
        get: {
            req: GetBulkByOutreachIdBulkUploadsOutreachOutreachIdGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<FileUpload>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        post: {
            req: MemoizeRmBasicBulkUploadForOutreachBulkUploadsOutreachOutreachIdPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: FileUpload;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/bulk_uploads/file/{file_uuid}': {
        get: {
            req: GetBulkUploadFileBulkUploadsFileFileUuidGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: BulkUploadFile;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/bulk_uploads/file': {
        patch: {
            req: UpdateBulkUploadFilesBulkUploadsFilePatchData;
            res: {
                /**
                 * Successful Response
                 */
                200: BulkUploadFile;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/bulk_uploads/bulk-upload-group/{file_uuid}': {
        get: {
            req: GetUploadGroupByFileUuidBulkUploadsBulkUploadGroupFileUuidGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: BulkUploadNoChildFiles;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/basic/single/{outreach_id}': {
        get: {
            req: GetSingleUploadsByOutreachIdBasicSingleOutreachIdGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<SingleUpload>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        post: {
            req: PersistSingleUploadByOutreachIdBasicSingleOutreachIdPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: FileUpload;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/basic/status': {
        patch: {
            req: UpdateFileStatusBasicStatusPatchData;
            res: {
                /**
                 * Successful Response
                 */
                200: FileUpload;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/basic/single/ai/{outreach_id}': {
        post: {
            req: PersistAiSingleUploadByOutreachIdBasicSingleAiOutreachIdPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: FileUpload;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/file-upload/basic/single': {
        get: {
            req: GetBasicSingleUploadsByOutreachIdV2FileUploadBasicSingleGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<SingleUpload>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/file-upload/basic/bulk': {
        get: {
            req: GetBasicBulkUploadsByOutreachIdV2FileUploadBasicBulkGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<FileUploadEntry>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/file-upload/standard/': {
        post: {
            req: GetSingleUploadsForRmStandardV2FileUploadStandardPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: StandardSingleUploadQueueResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/file-upload/standard/single-uploads/{tenant_uuid}': {
        get: {
            req: GetSingleUploadsWithPatientInfoForRmStandardV2FileUploadStandardSingleUploadsTenantUuidGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<StandardSingleUploadWithPatientInfo>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/v2/file-upload/general/file/{file_uuid}': {
        get: {
            req: GetFileByUuidV2FileUploadGeneralFileFileUuidGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: FileUploadEntry;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
};